import { PdfViewerBase } from '../index';
import { Browser, isBlazor, isNullOrUndefined, initializeCSPTemplate } from '@syncfusion/ej2-base';
import { splitArrayCollection, processPathData, cornersPointsBeforeRotation, getPathString } from '@syncfusion/ej2-drawings';
import { Tooltip } from '@syncfusion/ej2-popups';
/**
 * The `FormFields` module is to render formfields in the PDF document.
 *
 * @hidden
 */
export class FormFields {
    /**
     * @param {PdfViewer} viewer - It describes about the viewer
     * @param {PdfViewerBase} base - It describes about the base
     * @private
     * @returns {void}
     */
    constructor(viewer, base) {
        this.maintainTabIndex = {};
        this.maintanMinTabindex = {};
        this.isSignatureField = false;
        /**
         * @private
         */
        this.paddingDifferenceValue = 10;
        this.indicatorPaddingValue = 4;
        this.isKeyDownCheck = false;
        /**
         * @private
         */
        this.signatureFontSizeConstent = 1.35;
        /**
         * @private
         */
        this.readOnlyCollection = [];
        this.isSignatureRendered = false;
        /**
         * @private
         */
        this.signatureFieldCollection = [];
        this.selectedIndex = [];
        /**
         * @private
         */
        this.renderedPageList = [];
        this.pdfViewer = viewer;
        this.pdfViewerBase = base;
    }
    /**
     * @param {number} pageIndex - It describes about the page index
     * @param {boolean} isImportFormField - It describes about the isImportFormField
     * @private
     * @returns {void}
     */
    renderFormFields(pageIndex, isImportFormField) {
        this.maxTabIndex = 0;
        this.minTabIndex = -1;
        if (this.renderedPageList.indexOf(pageIndex) !== -1 && !isImportFormField) {
            this.data = this.pdfViewerBase.getItemFromSessionStorage('_formDesigner');
            if (!this.data || this.data === '[]') {
                this.data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
            }
        }
        else {
            this.data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
        }
        if (this.data) {
            this.formFieldsData = JSON.parse(this.data);
            if (this.formFieldsData[0] === '[') {
                this.formFieldsData = JSON.parse(this.formFieldsData);
            }
            const textLayer = document.getElementById(this.pdfViewer.element.id + '_textLayer_' + pageIndex);
            const canvasElement = document.getElementById(this.pdfViewer.element.id + '_pageCanvas_' + pageIndex);
            let count;
            if (this.formFieldsData !== null && canvasElement !== null && textLayer !== null) {
                let flag = false;
                for (let i = 0; i < this.formFieldsData.length; i++) {
                    const formField = this.formFieldsData[parseInt(i.toString(), 10)];
                    if (!flag && isNullOrUndefined(formField.ActualFieldName) && formField.PageIndex === pageIndex) {
                        count = parseInt(formField.FieldName.slice(formField.FieldName.lastIndexOf('_') + 1), 10);
                        flag = true;
                    }
                }
                if (this.renderedPageList.indexOf(pageIndex) === -1) {
                    this.renderedPageList.push(pageIndex);
                }
                for (let i = 0; i < this.formFieldsData.length; i++) {
                    const currentData = this.formFieldsData[parseInt(i.toString(), 10)];
                    if (currentData.FieldName !== '') {
                        if (currentData.IsInitialField) {
                            currentData.Name = 'InitialField';
                        }
                        const font = currentData['Font'];
                        if (this.pdfViewer.formDesigner) {
                            if (parseFloat(currentData['PageIndex']) === pageIndex) {
                                let fontFamily;
                                let fontStyle;
                                let fontSize;
                                if (!isNullOrUndefined(font) && font.Height) {
                                    fontFamily = font.Name;
                                    if (font.Italic) {
                                        fontStyle = 'Italic';
                                    }
                                    if (font.Bold) {
                                        fontStyle = 'Bold';
                                    }
                                    if (font.Strikeout) {
                                        fontStyle = 'Strikethrough';
                                    }
                                    if (font.Underline) {
                                        fontStyle = 'Underline';
                                    }
                                    fontSize = this.ConvertPointToPixel(font.Size);
                                }
                                const textAlignment = currentData.Alignment === 2 ? 'right' : (currentData.Alignment === 1 ? 'center' : 'left');
                                const backgroundColor = currentData['BackColor'];
                                const bounds = currentData['LineBounds'];
                                let backColor = 'rgba(' + backgroundColor.R + ',' + backgroundColor.G + ',' + backgroundColor.B + ',' + 1 + ')';
                                if (currentData.IsTransparent === true) {
                                    backColor = 'rgba(0,0,0,0)';
                                }
                                backColor = this.rgbaToHex(backColor);
                                // set default color if field have black color as bg.
                                if (backColor === '#000000ff') {
                                    backColor = '#daeaf7ff';
                                }
                                const fontColor = currentData['FontColor'];
                                const left = this.ConvertPointToPixel(bounds.X);
                                const top = this.ConvertPointToPixel(bounds.Y);
                                const width = this.ConvertPointToPixel(bounds.Width);
                                const height = this.ConvertPointToPixel(bounds.Height);
                                let boundArray = { left: left, top: top, width: width, height: height };
                                let isFieldRotated = false;
                                let rotateFieldAngle = 0;
                                if (currentData['Rotation'] !== 0) {
                                    if (currentData['RotationAngle'] === -90 || currentData['RotationAngle'] === -270 || currentData['RotationAngle'] === -180) {
                                        boundArray = this.getBounds(boundArray, pageIndex, 0, isFieldRotated);
                                    }
                                }
                                else {
                                    isFieldRotated = true;
                                    boundArray = this.getBounds(boundArray, pageIndex, 0, isFieldRotated);
                                    rotateFieldAngle = this.getAngle(pageIndex);
                                }
                                let foreColor = 'rgba(' + fontColor.R + ',' + fontColor.G + ',' + fontColor.B + ',' + 1 + ')';
                                foreColor = this.rgbaToHex(foreColor);
                                const borderColor = currentData['BorderColor'];
                                let borderRGB;
                                if (currentData.IsTansparentBorderColor) {
                                    borderRGB = 'rgba(' + borderColor.R + ',' + borderColor.G + ',' + borderColor.B + ',' + 0 + ')';
                                }
                                else {
                                    borderRGB = 'rgba(' + borderColor.R + ',' + borderColor.G + ',' + borderColor.B + ',' + 1 + ')';
                                }
                                borderRGB = this.rgbaToHex(borderRGB);
                                const borderWidth = currentData['BorderWidth'];
                                this.selectedIndex = [];
                                let elementValue = '';
                                if (currentData.Name === 'RadioButton' || currentData.Name === 'CheckBox') {
                                    elementValue = currentData['Text'] ? currentData['Text'] : currentData['Value'];
                                }
                                else {
                                    elementValue = currentData['Text'];
                                }
                                const indicatorSettings = (currentData['Name'] === 'SignatureField') ? this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings : this.pdfViewer.initialFieldSettings.initialIndicatorSettings;
                                const fieldProperties = {
                                    bounds: { X: boundArray.left, Y: boundArray.top, Width: boundArray.width,
                                        Height: boundArray.height }, pageNumber: parseFloat(currentData['PageIndex']) + 1,
                                    name: currentData['ActualFieldName'] ? currentData['ActualFieldName'] : currentData['FieldName'],
                                    tooltip: currentData['ToolTip'], value: elementValue, insertSpaces: currentData['InsertSpaces'],
                                    isChecked: currentData['Selected'], isSelected: currentData['Selected'], fontFamily: fontFamily,
                                    fontStyle: fontStyle, backgroundColor: backColor, color: foreColor, borderColor: borderRGB,
                                    thickness: borderWidth, fontSize: fontSize, isMultiline: currentData.Multiline,
                                    rotateAngle: rotateFieldAngle, isReadOnly: currentData['IsReadonly'],
                                    isRequired: currentData['IsRequired'], alignment: textAlignment,
                                    options: this.getListValues(currentData), selectedIndex: this.selectedIndex,
                                    maxLength: currentData.MaxLength, visibility: currentData.Visible === 1 ? 'hidden' : 'visible',
                                    font: { isItalic: !isNullOrUndefined(font) ? font.Italic : false, isBold: !isNullOrUndefined(font) ?
                                            font.Bold : false, isStrikeout: !isNullOrUndefined(font) ? font.Strikeout : false,
                                        isUnderline: !isNullOrUndefined(font) ? font.Underline : false },
                                    isTransparent: currentData.IsTransparent,
                                    customData: !isNullOrUndefined(currentData['CustomData']) ? typeof currentData['CustomData'] === 'object'
                                        ? currentData['CustomData'] : currentData['CustomData'].trim() !== ''
                                        ? JSON.parse(currentData['CustomData']) : '' : '',
                                    signatureIndicatorSettings: indicatorSettings
                                };
                                if (!currentData.id && this.pdfViewer.formFieldCollections[parseInt(i.toString(), 10)] && !isNullOrUndefined(currentData['ActualFieldName'])) {
                                    fieldProperties.id = this.pdfViewer.formFieldCollections[parseInt(i.toString(), 10)].id;
                                }
                                if (currentData.Name === 'DropDown' || currentData.Name === 'ListBox') {
                                    fieldProperties.value = currentData['SelectedValue'];
                                }
                                const fieldType = this.getFormFieldType(currentData);
                                if (currentData.Name !== 'SignatureText' || currentData.Name !== 'SignatureImage') {
                                    if (!isNullOrUndefined(this.getFormFieldType(currentData))) {
                                        if (currentData.IsRequired) {
                                            let thickness = fieldProperties.thickness;
                                            thickness = thickness > 0 ? thickness : 1;
                                            fieldProperties.thickness = thickness;
                                        }
                                        const addedElement1 = this.pdfViewer.formDesignerModule.
                                            addField(fieldType, fieldProperties, false, fieldProperties.id);
                                        if (addedElement1 && addedElement1.parentElement) {
                                            currentData.id = addedElement1.parentElement.id.split('_')[0];
                                        }
                                        if (addedElement1 && addedElement1.style.visibility === 'hidden') {
                                            addedElement1.childNodes[0].disabled = true;
                                        }
                                    }
                                }
                                if (fieldType === 'SignatureField' || fieldType === 'InitialField') {
                                    this.addSignaturePath(currentData, count);
                                    if (!isNullOrUndefined(currentData.Value) && currentData.Value !== '') {
                                        this.renderExistingAnnnot(currentData, parseFloat(currentData['PageIndex']) + 1, null, isFieldRotated);
                                        this.isSignatureRendered = true;
                                        count++;
                                    }
                                }
                                if (currentData.ActualFieldName == null && !isNullOrUndefined(currentData.FieldName) && this.formFieldsData.filter((item) => !isNullOrUndefined(item.FieldName) && item.FieldName.includes(currentData.FieldName.replace(/_\d$/, ''))).filter((value) => value.Name !== 'ink').length === 0) {
                                    this.renderExistingAnnnot(currentData, parseFloat(currentData['PageIndex']) + 1, null, isFieldRotated);
                                    this.pdfViewerBase.signatureModule.storeSignatureData(pageIndex, currentData);
                                    this.isSignatureRendered = true;
                                    count++;
                                }
                                this.pdfViewerBase.isLoadedFormFieldAdded = true;
                            }
                        }
                        else {
                            if (parseFloat(currentData['PageIndex']) === pageIndex) {
                                const field = this.createFormFields(currentData, pageIndex, i, null, count);
                                const inputField = field.currentField;
                                const signCount = field.count;
                                let isFieldRotated = false;
                                if (currentData.ActualFieldName === null && !isNullOrUndefined(currentData.FieldName) && this.formFieldsData.filter((item) => !isNullOrUndefined(item.FieldName) && item.FieldName.includes(currentData.FieldName.replace(/_\d$/, ''))).filter((value) => value.Name !== 'ink').length === 0) {
                                    this.renderExistingAnnnot(currentData, parseFloat(currentData['PageIndex']) + 1, null, isFieldRotated);
                                    this.pdfViewerBase.signatureModule.storeSignatureData(pageIndex, currentData);
                                    this.isSignatureRendered = true;
                                    count++;
                                }
                                if (inputField) {
                                    const divElement = this.createParentElement(currentData, pageIndex);
                                    const bounds = currentData['LineBounds'];
                                    const font = currentData['Font'];
                                    let rotateAngle = 0;
                                    if (currentData['Rotation'] === 0) {
                                        isFieldRotated = true;
                                        rotateAngle = this.getAngle(pageIndex);
                                        if (divElement) {
                                            divElement.style.transform = 'rotate(' + rotateAngle + 'deg)';
                                        }
                                        else {
                                            inputField.style.transform = 'rotate(' + rotateAngle + 'deg)';
                                        }
                                    }
                                    else {
                                        if (divElement) {
                                            divElement.style.transform = 'rotate(' + rotateAngle + 'deg)';
                                        }
                                        else {
                                            inputField.style.transform = 'rotate(' + rotateAngle + 'deg)';
                                        }
                                    }
                                    this.applyPosition(inputField, bounds, font, pageIndex, 0, isFieldRotated);
                                    inputField.InsertSpaces = currentData.InsertSpaces;
                                    if (inputField.InsertSpaces) {
                                        const zoomFactor = this.pdfViewerBase.getZoomFactor();
                                        const font = ((parseInt(inputField.style.width, 10) / inputField.maxLength)
                                            - (parseFloat(inputField.style.fontSize) / 2)) - (0.6 * zoomFactor);
                                        inputField.style.letterSpacing = '' + font + 'px';
                                        inputField.style.fontFamily = 'monospace';
                                        inputField.style.paddingLeft = (font / 2) + 'px';
                                    }
                                    currentData['uniqueID'] = this.pdfViewer.element.id + 'input_' + pageIndex + '_' + i;
                                    for (let j = 0; j < this.pdfViewer.formFieldCollections.length; j++) {
                                        if ((inputField.type === 'text' || inputField.type === 'password' || inputField.type === 'textarea') && currentData.Name !== 'SignatureField') {
                                            if (currentData['uniqueID'] === this.pdfViewer.formFieldCollections[parseInt(j.toString(), 10)].id) {
                                                this.pdfViewer.formFieldCollections[parseInt(j.toString(), 10)].value = currentData['Text'];
                                            }
                                        }
                                    }
                                    if (isNullOrUndefined(currentData.Value)) {
                                        currentData.Value = currentData['Text'];
                                    }
                                    if (currentData.ToolTip) {
                                        this.setToolTip(currentData.ToolTip, inputField);
                                    }
                                    this.applyCommonProperties(inputField, pageIndex, i, currentData, isFieldRotated);
                                    this.checkIsReadonly(currentData, inputField);
                                    this.applyTabIndex(currentData, inputField, pageIndex);
                                    this.checkIsRequiredField(currentData, inputField);
                                    this.applyDefaultColor(inputField);
                                    this.updateFormFieldsCollection(currentData);
                                    if (divElement) {
                                        divElement.appendChild(inputField);
                                        textLayer.appendChild(divElement);
                                    }
                                    else {
                                        inputField.style.position = 'absolute';
                                        textLayer.appendChild(inputField);
                                    }
                                    inputField.addEventListener('focus', this.focusFormFields.bind(this));
                                    inputField.addEventListener('blur', this.blurFormFields.bind(this));
                                    inputField.addEventListener('click', this.updateFormFields.bind(this));
                                    inputField.addEventListener('change', this.changeFormFields.bind(this));
                                    inputField.addEventListener('keydown', this.updateFormFieldsValue.bind(this));
                                    inputField.addEventListener('keyup', this.updateSameFieldsValue.bind(this));
                                    count = signCount;
                                }
                            }
                        }
                    }
                }
                if (!this.pdfViewer.formDesigner) {
                    PdfViewerBase.sessionStorageManager.removeItem(this.pdfViewerBase.documentId + '_formfields');
                    this.pdfViewerBase.setItemInSessionStorage(this.formFieldsData, '_formfields');
                }
            }
        }
        if (this.pdfViewerBase.isFocusField && this.pdfViewerBase.focusField) {
            const currentField = document.getElementById(this.pdfViewerBase.focusField.id);
            if (currentField) {
                if ((this.pdfViewerBase.focusField.type === 'SignatureField' || this.pdfViewerBase.focusField.type === 'InitialField') && this.pdfViewer.formDesignerModule) {
                    const y = this.pdfViewerBase.focusField.bounds.y;
                    const height = this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)].height;
                    this.pdfViewer.bookmark.goToBookmark(this.pdfViewerBase.focusField.pageIndex, height - y);
                }
                else {
                    currentField.focus();
                }
                this.pdfViewerBase.isFocusField = false;
                this.pdfViewerBase.focusField = [];
            }
        }
    }
    setToolTip(tooltipContent, targetElement) {
        //initialize tooltip component
        const tooltip = new Tooltip({
            content: initializeCSPTemplate(function () { return tooltipContent; })
        });
        // render initialized tooltip
        tooltip.appendTo(targetElement);
    }
    trim(str) {
        return str.replace(/^\s+|\s+$/gm, '');
    }
    rgbaToHex(rgba) {
        const inParts = rgba.substring(rgba.indexOf('(')).split(',');
        const r = parseInt(this.trim(inParts[0].substring(1)), 10);
        const g = parseInt(this.trim(inParts[1]), 10);
        const b = parseInt(this.trim(inParts[2]), 10);
        const a = parseFloat(parseFloat(this.trim(inParts[3].substring(0, inParts[3].length - 1))).toFixed(2));
        const outParts = [
            r.toString(16),
            g.toString(16),
            b.toString(16),
            Math.round(a * 255).toString(16).substring(0, 2)
        ];
        // Pad single-digit output values
        outParts.forEach(function (part, i) {
            if (part.length === 1) {
                outParts[parseInt(i.toString(), 10)] = '0' + part;
            }
        });
        return ('#' + outParts.join(''));
    }
    getListValues(currentData) {
        let listItem = currentData['TextList'];
        const options = [];
        if (this.getFormFieldType(currentData) === 'DropDown') {
            listItem = currentData['ComboBoxList'];
            if (!isNullOrUndefined(listItem)) {
                for (let i = 0; i < listItem.length; i++) {
                    const itemValue = listItem[parseInt(i.toString(), 10)].itemValue ?
                        listItem[parseInt(i.toString(), 10)].itemValue : listItem[parseInt(i.toString(), 10)].ItemValue;
                    const itemName = listItem[parseInt(i.toString(), 10)].itemName ? listItem[parseInt(i.toString(), 10)].itemName
                        : listItem[parseInt(i.toString(), 10)].ItemName;
                    if (itemName === currentData['SelectedValue']) {
                        this.selectedIndex.push(i);
                    }
                    options.push({ itemName: itemName, itemValue: itemValue });
                }
            }
        }
        else {
            for (let i = 0; i < listItem.length; i++) {
                if (listItem[parseInt(i.toString(), 10)] === currentData['SelectedValue']) {
                    this.selectedIndex.push(i);
                }
                options.push({ itemName: listItem[parseInt(i.toString(), 10)], itemValue: listItem[parseInt(i.toString(), 10)] });
            }
        }
        if (this.getFormFieldType(currentData) === 'ListBox') {
            this.selectedIndex = currentData['SelectedList'];
        }
        return options;
    }
    createParentElement(data, pageIndex) {
        let divElement;
        if (data['Name'] === 'Textbox' || data['Name'] === 'Password') {
            divElement = document.createElement('div');
            divElement.style.background = 'white';
            if (data.InsertSpaces) {
                divElement.style.background = 'transparent';
            }
            const bounds = data['LineBounds'];
            const font = data['Font'];
            divElement.style.position = 'absolute';
            let isFieldRotated = false;
            if (data['Rotation'] === 0) {
                isFieldRotated = true;
            }
            this.applyPosition(divElement, bounds, font, pageIndex, 0, isFieldRotated);
        }
        return divElement;
    }
    /**
     * @param {number} pageIndex -  It describes about the page index
     * @param {any} data - It gets the page data
     * @private
     * @returns {number} - number
     */
    getAngle(pageIndex, data) {
        let angle = 0;
        const pageDetails = this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)];
        let pageRotation;
        if (!pageDetails && data && data.pageSizes && data.pageSizes[parseInt(pageIndex.toString(), 10)]) {
            pageRotation = data.pageRotation[parseInt(pageIndex.toString(), 10)];
        }
        else if (pageDetails && pageDetails.rotation) {
            pageRotation = pageDetails.rotation;
        }
        if ((pageDetails || data.pageSizes[parseInt(pageIndex.toString(), 10)]) && pageRotation) {
            switch (pageRotation) {
                case 0:
                    angle = 0;
                    break;
                case 1:
                    angle = 90;
                    break;
                case 2:
                    angle = 180;
                    break;
                case 3:
                    angle = 270;
                    break;
            }
        }
        return angle;
    }
    nextField() {
        this.signatureFieldNavigate(true);
    }
    previousField() {
        this.signatureFieldNavigate(false);
    }
    signatureFieldNavigate(nextSign) {
        const isNextSignField = nextSign;
        let signatureFields = this.signatureFieldCollection;
        const collectionData = this.pdfViewer.formFieldCollections;
        if (signatureFields.length === 0) {
            signatureFields = this.pdfViewerBase.signatureModule.getSignField();
        }
        let currentField;
        if (this.currentTarget) {
            if (this.pdfViewer.formDesignerModule) {
                for (let i = 0; i < collectionData.length; i++) {
                    currentField = collectionData[parseInt(i.toString(), 10)];
                    if (this.currentTarget.id === currentField.id) {
                        this.currentTarget = document.getElementById(currentField.id);
                        this.getSignatureIndex(i, collectionData.length, isNextSignField);
                        break;
                    }
                }
            }
            else {
                for (let i = 0; i < signatureFields.length; i++) {
                    currentField = this.pdfViewer.formDesignerModule ? signatureFields[parseInt(i.toString(), 10)].
                        FormField : signatureFields[parseInt(i.toString(), 10)];
                    if (this.currentTarget.id === currentField.uniqueID) {
                        this.currentTarget = document.getElementById(currentField.uniqueID);
                        this.getSignatureIndex(i, signatureFields.length, isNextSignField);
                        break;
                    }
                }
            }
        }
        else {
            if (nextSign) {
                if (this.pdfViewer.formDesignerModule) {
                    currentField = signatureFields[0];
                    if (currentField.id) {
                        this.currentTarget = document.getElementById(currentField.id);
                        this.getSignatureIndex(0, signatureFields.length, isNextSignField, true);
                    }
                }
                else {
                    currentField = signatureFields[0];
                    if (currentField.uniqueID) {
                        this.currentTarget = document.getElementById(currentField.uniqueID);
                        this.getSignatureIndex(0, signatureFields.length, isNextSignField, true);
                    }
                }
            }
        }
    }
    getSignatureIndex(currentSignatureIndex, signatureCount, isNextSign, isFirstNavigate) {
        let signatureIndex = currentSignatureIndex;
        if (!isFirstNavigate) {
            if (isNextSign) {
                signatureIndex++;
            }
            else {
                signatureIndex--;
            }
        }
        if (signatureCount === 1) {
            this.renderSignatureField(0);
        }
        else {
            if (signatureIndex < signatureCount && signatureIndex >= 0) {
                this.renderSignatureField(signatureIndex);
            }
            else {
                if (isNextSign) {
                    if (signatureIndex >= signatureCount) {
                        this.renderSignatureField(0);
                    }
                }
                else {
                    if (signatureIndex <= 0) {
                        this.renderSignatureField(signatureCount - 1);
                    }
                }
            }
        }
    }
    renderSignatureField(currentSignIndex) {
        const curSignIndex = currentSignIndex;
        const signatureFields = this.signatureFieldCollection;
        const collectionData = this.pdfViewer.formFieldCollections;
        let currentField;
        if (curSignIndex < collectionData.length) {
            for (let i = 0; i < collectionData.length; i++) {
                if (this.pdfViewer.formDesignerModule) {
                    const curSignIndexId = collectionData[parseInt(curSignIndex.toString(), 10)].id;
                    const signatureFieldData = collectionData[parseInt(i.toString(), 10)];
                    if (curSignIndexId === signatureFieldData.id) {
                        const pageIndex = signatureFieldData.pageIndex >= 0 ? signatureFieldData.pageIndex :
                            signatureFieldData.pageNumber;
                        const isRender = this.pdfViewer.annotationModule.findRenderPageList(pageIndex);
                        if (!isRender) {
                            this.pdfViewer.navigation.goToPage(pageIndex + 1);
                            this.renderFormFields(pageIndex, false);
                        }
                        this.currentTarget = document.getElementById(signatureFieldData.id);
                        currentField = signatureFieldData;
                        break;
                    }
                }
                else {
                    const curSignIndexId = this.pdfViewer.formDesignerModule ?
                        signatureFields[parseInt(curSignIndex.toString(), 10)].FormField.uniqueID :
                        signatureFields[parseInt(curSignIndex.toString(), 10)].uniqueID;
                    const signatureFieldData = this.pdfViewer.formDesignerModule ? signatureFields[parseInt(i.toString(), 10)].
                        FormField : signatureFields[parseInt(i.toString(), 10)];
                    if (curSignIndexId === signatureFieldData.uniqueID) {
                        const pageIndex = signatureFieldData.PageIndex >= 0 ? signatureFieldData.PageIndex :
                            signatureFieldData.pageNumber;
                        const isRender = this.pdfViewer.annotationModule.findRenderPageList(pageIndex);
                        if (!isRender) {
                            this.pdfViewer.navigation.goToPage(pageIndex + 1);
                            this.renderFormFields(pageIndex, false);
                        }
                        this.currentTarget = document.getElementById(signatureFieldData.uniqueID);
                        currentField = signatureFieldData;
                        break;
                    }
                }
            }
            if (this.currentTarget === null) {
                const pageIndex = currentField.PageIndex >= 0 ? currentField.PageIndex : currentField.pageNumber;
                this.pdfViewer.navigation.goToPage(pageIndex);
                this.currentTarget = document.getElementById(currentField.uniqueID);
            }
            if (this.currentTarget) {
                if (this.currentTarget.className === 'e-pdfviewer-signatureformfields-signature' && !(this.pdfViewer.formDesignerModule)) {
                    document.getElementById(this.currentTarget.id).focus();
                    this.pdfViewer.select([this.currentTarget.id], null);
                }
                else if (this.currentTarget.className === 'e-pdfviewer-signatureformfields' || this.currentTarget.className === 'e-pdfviewer-signatureformfields-signature') {
                    if (this.pdfViewer.formDesignerModule) {
                        document.getElementById(this.currentTarget.id).parentElement.focus();
                    }
                    else {
                        document.getElementById(this.currentTarget.id).focus();
                    }
                }
            }
        }
    }
    /**
     * @param {any} pageData - It gets the page data
     * @private
     * @returns {void}
     */
    formFieldCollections(pageData) {
        const data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
        if (data) {
            const formFieldsData = JSON.parse(data);
            for (let i = 0; i < formFieldsData.length; i++) {
                const currentData = formFieldsData[parseInt(i.toString(), 10)];
                const type = currentData['Name'];
                if (this.pdfViewer.formDesignerModule) {
                    if (currentData.Name !== 'ink' && currentData.Name !== 'SignatureImage' && currentData.Name !== 'SignatureText') {
                        this.retreiveFormFieldsData(currentData, true, pageData);
                    }
                    else {
                        const index = this.pdfViewer.formFieldCollections.findIndex((field) => (field.type === 'SignatureField' || field.type === 'InitialField') &&
                            currentData.FieldName && currentData.FieldName.includes(field.name) &&
                            currentData.FieldName.includes(field.name + '_'));
                        if (index >= 0) {
                            let value = currentData.Value;
                            if (currentData.Name === 'ink') {
                                const collectionData = processPathData(value);
                                const csData = splitArrayCollection(collectionData);
                                value = JSON.stringify(csData);
                            }
                            this.pdfViewer.formFieldCollections[parseInt(index.toString(), 10)].value = value;
                        }
                    }
                }
                else {
                    if (currentData.Name !== 'ink') {
                        let bounds;
                        if (currentData.LineBounds) {
                            if (isNullOrUndefined(currentData.Bounds)) {
                                bounds = this.updateBoundsValue(currentData.LineBounds);
                            }
                            else {
                                bounds = currentData.Bounds;
                            }
                        }
                        const formFieldCollection = {
                            name: this.retriveFieldName(currentData),
                            id: this.pdfViewer.element.id + 'input_' + parseFloat(currentData['PageIndex']) + '_' + i,
                            isReadOnly: false, type: currentData.IsInitialField ? 'InitialField' : type,
                            value: this.retriveCurrentValue(currentData), fontName: '', isRequired: currentData.IsRequired, bounds: bounds
                        };
                        this.pdfViewer.formFieldCollections.push(formFieldCollection);
                    }
                }
            }
        }
    }
    retreiveFormFieldsData(currentData, isCollection, data) {
        let fontFamily;
        let fontStyle;
        let fontSize;
        if (currentData.FieldName !== '') {
            if (currentData.IsInitialField) {
                currentData.Name = 'InitialField';
            }
            const font = currentData['Font'];
            if (!isNullOrUndefined(font) && font.Height) {
                fontFamily = font.Name;
                if (font.Italic) {
                    fontStyle = 'Italic';
                }
                if (font.Bold) {
                    fontStyle = 'Bold';
                }
                if (font.Strikeout) {
                    fontStyle = 'Strikethrough';
                }
                if (font.Underline) {
                    fontStyle = 'Underline';
                }
                fontSize = this.ConvertPointToPixel(font.Size);
            }
            const textAlignment = currentData.Alignment === 2 ? 'right' : (currentData.Alignment === 1 ? 'center' : 'left');
            const backgroundColor = currentData['BackColor'];
            const bounds = currentData['LineBounds'];
            let backColor = 'rgba(' + backgroundColor.R + ',' + backgroundColor.G + ',' + backgroundColor.B + ',' + 1 + ')';
            backColor = this.rgbaToHex(backColor);
            // set default color if field have black color as bg.
            if (currentData.IsTransparent === true) {
                backColor = 'rgba(0,0,0,0)';
            }
            else if (backColor === '#000000ff') {
                backColor = '#daeaf7ff';
            }
            const fontColor = currentData['FontColor'];
            const left = this.ConvertPointToPixel(bounds.X);
            const top = this.ConvertPointToPixel(bounds.Y);
            const width = this.ConvertPointToPixel(bounds.Width);
            const height = this.ConvertPointToPixel(bounds.Height);
            let foreColor = 'rgba(' + fontColor.R + ',' + fontColor.G + ',' + fontColor.B + ',' + 1 + ')';
            foreColor = this.rgbaToHex(foreColor);
            const borderColor = currentData['BorderColor'];
            let borderRGB = 'rgba(' + borderColor.R + ',' + borderColor.G + ',' + borderColor.B + ',' + 1 + ')';
            borderRGB = this.rgbaToHex(borderRGB);
            if (currentData.IsTansparentBorderColor === true) {
                borderRGB = 'rgba(0,0,0,0)';
            }
            const borderWidth = currentData['BorderWidth'];
            this.selectedIndex = [];
            let boundArray = { left: left, top: top, width: width, height: height };
            let isFieldRotated = false;
            let rotateFieldAngle = 0;
            if (currentData['Rotation'] !== 0) {
                if (currentData['RotationAngle'] === -90 || currentData['RotationAngle'] === -270 || currentData['RotationAngle'] === -180) {
                    boundArray = this.getBounds(boundArray, currentData.PageIndex, 0, isFieldRotated, data);
                }
            }
            else {
                isFieldRotated = true;
                boundArray = this.getBounds(boundArray, currentData.PageIndex, 0, isFieldRotated, data);
                rotateFieldAngle = this.getAngle(currentData.PageIndex, data);
            }
            const fieldProperties = {
                bounds: { X: boundArray.left, Y: boundArray.top, Width: boundArray.width, Height: boundArray.height },
                pageNumber: parseFloat(currentData['PageIndex']) + 1, name: currentData['ActualFieldName'], tooltip: currentData['ToolTip'],
                value: currentData['Text'], isChecked: currentData['Selected'], isSelected: currentData['Selected'], fontFamily: fontFamily,
                fontStyle: fontStyle, backgroundColor: backColor, color: foreColor, borderColor: borderRGB, thickness: borderWidth,
                fontSize: fontSize, isMultiline: currentData.Multiline,
                isReadOnly: currentData['IsReadonly'], isRequired: currentData['IsRequired'], insertSpaces: currentData['InsertSpaces'],
                alignment: textAlignment, options: this.getListValues(currentData), selectedIndex: this.selectedIndex,
                maxLength: currentData.MaxLength, visibility: currentData.Visible === 1 ? 'hidden' : 'visible',
                font: { isItalic: !isNullOrUndefined(font) ? font.Italic : false, isBold: !isNullOrUndefined(font) ? font.Bold : false,
                    isStrikeout: !isNullOrUndefined(font) ? font.Strikeout : false, isUnderline: !isNullOrUndefined(font) ?
                        font.Underline : false }, pageIndex: currentData['PageIndex'], isTransparent: currentData['IsTransparent'],
                rotationAngle: currentData['RotationAngle'], signatureType: currentData['SignatureType'] ? currentData['SignatureType'] : '',
                signatureIndicatorSettings: currentData['SignatureIndicatorSettings'], zIndex: currentData['zIndex'],
                customData: !isNullOrUndefined(currentData['CustomData']) ? typeof currentData['CustomData'] === 'object'
                    ? currentData['CustomData'] : currentData['CustomData'].trim() !== ''
                    ? JSON.parse(currentData['CustomData']) : '' : ''
            };
            if (currentData.Name === 'DropDown' || currentData.Name === 'ListBox') {
                fieldProperties.value = currentData['SelectedValue'];
            }
            if (currentData.Name === 'RadioButton') {
                fieldProperties.value = currentData['Value'];
            }
            const fieldType = this.getFormFieldType(currentData);
            if (fieldType === 'SignatureField' || fieldType === 'InitialField') {
                this.addSignaturePath(currentData);
                if (this.isSignatureField) {
                    fieldProperties.value = currentData.Value;
                }
            }
            const addedElement = this.pdfViewer.formDesignerModule.addField(fieldType, fieldProperties, isCollection);
            return addedElement;
        }
        return null;
    }
    updateBoundsValue(lineBounds) {
        const bounds = {
            x: this.ConvertPointToPixel(lineBounds.X), y: this.ConvertPointToPixel(lineBounds.Y),
            width: this.ConvertPointToPixel(lineBounds.Width), height: this.ConvertPointToPixel(lineBounds.Height)
        };
        return bounds;
    }
    /**
     * @param {any} formField - It describes about the form field
     * @private
     * @returns {void}
     */
    updateFormFieldsCollection(formField) {
        const type = formField['Name'];
        let bounds;
        if (formField.LineBounds) {
            if (isNullOrUndefined(formField.Bounds)) {
                bounds = this.updateBoundsValue(formField.LineBounds);
            }
            else {
                bounds = formField.Bounds;
            }
        }
        const textList = (formField.Name === 'DropDown') ? formField.ComboBoxList : formField.TextList;
        const formFieldCollection = {
            name: this.retriveFieldName(formField), id: formField.uniqueID, isReadOnly: formField.IsReadonly,
            isRequired: formField.IsRequired, isSelected: formField.Selected,
            isChecked: type === 'RadioButton' ? false : formField.Selected, type: type, value: type === 'ListBox' || type === 'DropDown' ?
                formField.SelectedValue : (type === 'Textbox' || type === 'Password') ? formField.Text : formField.Value, fontName: formField.FontFamily ? formField.FontFamily : '',
            pageIndex: formField.PageIndex, pageNumber: formField.PageIndex + 1, isMultiline: formField.isMultiline ?
                formField.isMultiline : formField.Multiline, insertSpaces: formField.insertSpaces ?
                formField.insertSpaces : formField.InsertSpaces, isTransparent: formField.isTransparent ? formField.isTransparent :
                formField.IsTransparent, rotateAngle: formField.rotateAngle ? formField.rotateAngle : formField.RotationAngle,
            selectedIndex: formField.selectedIndex ? formField.selectedIndex : formField.SelectedList,
            options: formField.options ? formField.options : textList ? textList : [], bounds: bounds,
            signatureType: formField.signatureType ? formField.signatureType : '', zIndex: formField.zIndex, tooltip: formField.tooltip ?
                formField.tooltip : formField.ToolTip ? formField.ToolTip : '', signatureIndicatorSettings: formField.signatureIndicatorSettings ?
                formField.signatureIndicatorSettings : ''
        };
        this.pdfViewer.formFieldCollections[this.pdfViewer.formFieldCollections.
            findIndex((el) => el.id === formFieldCollection.id)] = formFieldCollection;
    }
    updateFormFieldValues(formFields) {
        this.readOnlyCollection.push(formFields.id);
        if (formFields) {
            const currentElement = document.getElementById(formFields.id);
            if (currentElement) {
                if (formFields.isReadOnly) {
                    currentElement.disabled = true;
                    currentElement.style.backgroundColor = '';
                    currentElement.style.cursor = 'default';
                }
                else {
                    if (currentElement.style.backgroundColor === '') {
                        currentElement.style.backgroundColor = 'rgba(0, 20, 200, 0.2)';
                    }
                    currentElement.disabled = false;
                    currentElement.style.cursor = '';
                }
            }
            this.updateDataInSession(currentElement);
        }
    }
    /**
     * @param {any} currentData - It describes about the current data
     * @private
     * @returns {string} - string
     */
    retriveFieldName(currentData) {
        let currentField;
        switch (currentData['Name']) {
            case 'Textbox':
            case 'Password':
            case 'SignatureField':
            case 'InitialField':
                currentField = currentData.FieldName;
                break;
            case 'RadioButton':
            case 'CheckBox':
                currentField = currentData.GroupName;
                break;
            case 'DropDown':
                currentField = currentData.ActualFieldName;
                break;
            case 'ListBox':
                currentField = currentData.Text;
                break;
        }
        return currentField;
    }
    retriveCurrentValue(currentData) {
        let currentField;
        switch (currentData['Name']) {
            case 'Textbox':
            case 'Password':
                currentField = currentData.Text;
                break;
            case 'SignatureField':
                currentField = currentData.Value;
                break;
            case 'RadioButton':
            case 'CheckBox':
                currentField = currentData.Selected;
                break;
            case 'DropDown':
                currentField = currentData.SelectedValue;
                break;
            case 'ListBox':
                currentField = currentData.SelectedList;
                break;
        }
        return currentField;
    }
    getSignatureBounds(LineBounds, bounds, pageIndex) {
        const pageDetails = this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)];
        let bound = 0;
        switch (pageDetails.rotation) {
            case 0:
                bound = bounds;
                break;
            case 1:
                bound = { x: bounds.x + LineBounds.Width + (bounds.width / 3.5), y: pageDetails.width - LineBounds.X + (bounds.height / 4) };
                break;
            case 2:
                bound = { x: pageDetails.width - bounds.x - bounds.width, y: pageDetails.height - bounds.y - bounds.height };
                break;
            case 3:
                bound = { x: bounds.y - (bounds.width / 2) + bounds.height, y: bounds.x + (bounds.width / 3) };
                break;
        }
        return bound;
    }
    /**
     * @private
     * @returns {any} - any
     */
    downloadFormFieldsData() {
        const data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
        if (data) {
            const formFieldsData = JSON.parse(data);
            const datas = {};
            let fieldDatas = [];
            for (let m = 0; m < formFieldsData.length; m++) {
                const currentData = formFieldsData[parseInt(m.toString(), 10)];
                const isRequired = currentData.IsRequired;
                if (currentData.Name === 'Textbox' || currentData.Name === 'Password' || currentData.Multiline) {
                    if (isRequired && (currentData.Text === '' || currentData.Text === null)) {
                        this.pdfViewerBase.validateForm = true;
                        this.pdfViewerBase.nonFillableFields[currentData.FieldName] = currentData.Text;
                    }
                    else {
                        delete (this.pdfViewerBase.nonFillableFields[currentData.FieldName]);
                    }
                    fieldDatas = { fieldValue: currentData.Text, isReadOnly: currentData.IsReadonly };
                    datas[currentData.FieldName] = fieldDatas;
                }
                else if (currentData.Name === 'RadioButton' && currentData.Selected) {
                    if (isRequired && currentData.Selected === false) {
                        this.pdfViewerBase.validateForm = true;
                        this.pdfViewerBase.nonFillableFields[currentData.GroupName] = currentData.Value;
                    }
                    else {
                        delete (this.pdfViewerBase.nonFillableFields[currentData.GroupName]);
                    }
                    fieldDatas = { fieldValue: currentData.Value, isReadOnly: currentData.IsReadonly };
                    datas[currentData.GroupName] = fieldDatas;
                }
                else if (currentData.Name === 'CheckBox') {
                    if (isRequired && currentData.Selected === false) {
                        this.pdfViewerBase.validateForm = true;
                        this.pdfViewerBase.nonFillableFields[currentData.GroupName] = currentData.Selected;
                    }
                    else {
                        delete (this.pdfViewerBase.nonFillableFields[currentData.GroupName]);
                    }
                    const currentCheckBoxIndex = currentData.CheckBoxIndex ? currentData.CheckBoxIndex :
                        currentData.CheckboxIndex ? currentData.CheckboxIndex : null;
                    if (currentCheckBoxIndex && currentData.Selected) {
                        fieldDatas = { isSelected: currentCheckBoxIndex, isReadOnly: currentData.IsReadonly,
                            fieldValue: !isNullOrUndefined(currentData.Value) ? currentData.Value : '' };
                        datas[currentData.GroupName] = fieldDatas;
                    }
                    else if (datas[currentData.GroupName] === undefined || datas[currentData.GroupName] === null) {
                        fieldDatas = { isSelected: currentData.Selected, isReadOnly: currentData.IsReadonly, fieldValue: currentData.Value };
                        datas[currentData.GroupName] = fieldDatas;
                    }
                }
                else if (currentData.Name === 'DropDown') {
                    if (isRequired && currentData.SelectedValue === '') {
                        this.pdfViewerBase.validateForm = true;
                        this.pdfViewerBase.nonFillableFields[currentData.Text] = currentData.SelectedValue;
                    }
                    else {
                        delete (this.pdfViewerBase.nonFillableFields[currentData.Text]);
                    }
                    fieldDatas = { fieldValue: currentData.SelectedValue, isReadOnly: currentData.IsReadonly };
                    datas[currentData.FieldName] = fieldDatas;
                }
                else if (currentData.Name === 'ListBox') {
                    const childItems = currentData['TextList'];
                    const childItemsText = [];
                    for (let m = 0; m < currentData.SelectedList.length; m++) {
                        const currentElement = currentData.SelectedList[parseInt(m.toString(), 10)];
                        childItemsText.push(childItems[`${currentElement}`]);
                    }
                    fieldDatas = { fieldValue: JSON.stringify(childItemsText), isReadOnly: currentData.IsReadonly };
                    datas[currentData.Text] = fieldDatas;
                }
                else if (currentData.Name === 'SignatureField' || currentData.Name === 'InitialField') {
                    let csData;
                    if (isRequired && (currentData.Value === null || currentData.Value === '')) {
                        this.addSignaturePath(currentData);
                    }
                    if (currentData.Value && currentData.Value !== '') {
                        csData = currentData.Value;
                        const fontFamily = currentData.fontFamily ? currentData.fontFamily : currentData.FontFamily;
                        if (fontFamily) {
                            datas[currentData.FieldName + 'fontName'] = fontFamily;
                            datas[currentData.FieldName + 'fontSize'] = currentData.fontSize ? currentData.fontSize : currentData.FontSize;
                        }
                        else if (currentData.Value.split('base64,')[1]) {
                            datas[currentData.FieldName + 'ImageData'] = true;
                        }
                        else {
                            const collectionData = processPathData(currentData.Value);
                            csData = splitArrayCollection(collectionData);
                        }
                    }
                    if (isRequired && (currentData.Value === null || currentData.Value === '')) {
                        this.pdfViewerBase.validateForm = true;
                        this.pdfViewerBase.nonFillableFields[currentData.FieldName] = JSON.stringify(csData);
                    }
                    else {
                        delete (this.pdfViewerBase.nonFillableFields[currentData.FieldName]);
                    }
                    datas[currentData.FieldName] = JSON.stringify(csData);
                    if (currentData.Bounds) {
                        const bounds = this.getSignatureBounds(currentData.LineBounds, currentData.Bounds, currentData.PageIndex);
                        currentData.Bounds.x = bounds.x;
                        currentData.Bounds.y = bounds.y;
                        datas[currentData.FieldName + 'bounds'] = JSON.stringify(currentData.Bounds);
                    }
                    else {
                        const lineBounds = currentData.LineBounds;
                        const bounds = { x: this.ConvertPointToPixel(lineBounds.X), y: this.ConvertPointToPixel(lineBounds.Y),
                            width: this.ConvertPointToPixel(lineBounds.Width), height: this.ConvertPointToPixel(lineBounds.Height) };
                        datas[currentData.FieldName + 'bounds'] = JSON.stringify(bounds);
                    }
                    datas[currentData.FieldName + 'isReadOnly'] = currentData.IsReadonly;
                }
            }
            return (JSON.stringify(datas));
        }
    }
    focusFormFields(event) {
        const currentTarget = event.target;
        if (currentTarget && (currentTarget.className !== 'e-pdfviewer-signatureformfields' && currentTarget.className !== 'e-pdfviewer-signatureformfields e-pv-signature-focus')) {
            const backgroundcolor = currentTarget.style.backgroundColor;
            const currentIndex = backgroundcolor.lastIndexOf(',');
            const currentColor = backgroundcolor.slice(0, currentIndex + 1) + 0 + ')';
            currentTarget.style.backgroundColor = currentColor;
            if (currentTarget.type === 'checkbox') {
                currentTarget.style.webkitAppearance = '';
            }
            currentTarget.style.boxShadow = '0 0 5px ' + (currentTarget.style.borderColor === 'transparent' ? '#000000' : currentTarget.style.borderColor);
        }
        else if (currentTarget) {
            if (currentTarget.className === 'e-pdfviewer-signatureformfields' || currentTarget.className === 'e-pdfviewer-signatureformfields-signature' || currentTarget.className === 'e-pdfviewer-signatureformfields e-pv-signature-focus' || currentTarget.className === 'e-pdfviewer-signatureformfields-signature  e-pv-signature-focus') {
                this.pdfViewerBase.signatureModule.setFocus(currentTarget.id);
            }
        }
    }
    blurFormFields(event) {
        const currentTarget = event.target;
        if (currentTarget.InsertSpaces && this.isKeyDownCheck) {
            const font = parseInt(currentTarget.style.width, 10) - (parseInt(currentTarget.style.height, 10) / 2);
            currentTarget.style.width = '' + font + 'px';
            this.isKeyDownCheck = false;
        }
        if (currentTarget.type === 'checkbox') {
            this.pdfViewer.fireFocusOutFormField(currentTarget.name, currentTarget.checked);
        }
        else {
            this.pdfViewer.fireFocusOutFormField(currentTarget.name, currentTarget.value);
        }
        const backgroundcolor = currentTarget.style.backgroundColor;
        const currentIndex = backgroundcolor.lastIndexOf(',');
        const currentColor = backgroundcolor.slice(0, currentIndex + 1) + 0.2 + ')';
        currentTarget.style.backgroundColor = currentColor;
        currentTarget.style.boxShadow = 'none';
        if ((currentTarget.type === 'checkbox') && !currentTarget.checked) {
            currentTarget.style.webkitAppearance = 'none';
        }
        else {
            currentTarget.style.webkitAppearance = '';
        }
    }
    updateFormFields(event) {
        let currentTarget = event.target;
        if (this.pdfViewerBase.isDeviceiOS && currentTarget.type === 'checkbox') {
            currentTarget.focus();
        }
        if (currentTarget.className === 'e-pdfviewer-ListBox') {
            currentTarget = currentTarget.parentElement;
            this.updateDataInSession(currentTarget);
        }
        else if (currentTarget.className === 'e-pdfviewer-signatureformfields' || currentTarget.className === 'e-pdfviewer-signatureformfields e-pv-signature-focus') {
            this.currentTarget = currentTarget;
        }
        else if (currentTarget.className === 'e-pv-buttonItem' || currentTarget.type === 'button') {
            this.pdfViewer.fireButtonFieldClickEvent(currentTarget.value, currentTarget.name, currentTarget.id);
        }
        for (let m = 0; m < this.pdfViewer.formFieldCollections.length; m++) {
            if (currentTarget.id === this.pdfViewer.formFieldCollections[parseInt(m.toString(), 10)].id) {
                if (this.pdfViewer.formDesignerModule || this.pdfViewer.annotationModule) {
                    this.pdfViewer.fireFormFieldClickEvent('formFieldClicked', this.pdfViewer.formFieldCollections[parseInt(m.toString(), 10)]);
                }
                if (currentTarget.className === 'e-pdfviewer-signatureformfields' || currentTarget.className === 'e-pdfviewer-signatureformfields-signature' || currentTarget.className === 'e-pdfviewer-signatureformfields e-pv-signature-focus' || currentTarget.className === 'e-pdfviewer-signatureformfields-signature  e-pv-signature-focus') {
                    this.pdfViewerBase.signatureModule.setFocus(currentTarget.id);
                }
            }
        }
    }
    /**
     * @param {string} signatureType - It describes about the signature type
     * @param {string} value - It describes about the value
     * @param {any} target - It describes about the target
     * @param {string} fontname - It describes about the font name
     * @param {any} signBounds - It contains a signatureBounds
     * @private
     * @returns {void}
     */
    drawSignature(signatureType, value, target, fontname, signBounds) {
        let annot;
        // eslint-disable-next-line
        const proxy = this;
        let bounds;
        let targetBounds;
        let parentElementBounds;
        let data;
        if (this.pdfViewer.formDesigner) {
            data = this.pdfViewerBase.getItemFromSessionStorage('_formDesigner');
        }
        else {
            data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
        }
        const formFieldsData = JSON.parse(data);
        let targetName;
        if (this.pdfViewer.formDesignerModule) {
            targetName = this.currentTarget && this.currentTarget.offsetParent ? this.currentTarget.offsetParent.name :
                this.currentTarget ? this.currentTarget.name : target.name ? target.name : target.offsetParent.name;
        }
        else {
            targetName = this.currentTarget ? this.currentTarget.name : target.name ? target.name : target.offsetParent.name;
        }
        for (let i = 0; i < formFieldsData.length; i++) {
            const fieldName = this.pdfViewer.formDesigner ? formFieldsData[parseInt(i.toString(), 10)].
                FormField.name : formFieldsData[parseInt(i.toString(), 10)].FieldName;
            if (this.pdfViewer.formDesigner ? fieldName === targetName : fieldName === targetName &&
                (!isNullOrUndefined(formFieldsData[parseInt(i.toString(), 10)].ActualFieldName))) {
                target = this.pdfViewer.formDesigner ? document.getElementById(formFieldsData[parseInt(i.toString(), 10)].Key.split('_')[0]) : document.getElementById(formFieldsData[parseInt(i.toString(), 10)].uniqueID);
                const currentField = target;
                let signatureAdd = true;
                this.pdfViewer.annotations.filter(function (item) {
                    if (!isNullOrUndefined(currentField) && item.id === target.id + '_content') {
                        signatureAdd = false;
                    }
                });
                if (!isNullOrUndefined(currentField)) {
                    const elementId = currentField.offsetParent.offsetParent.id.split('_')[0];
                    const signatureField = this.pdfViewer.nameTable[`${elementId}`];
                    if (target && target.offsetParent && signatureField) {
                        targetBounds = target.getBoundingClientRect();
                        parentElementBounds = target.offsetParent.offsetParent.offsetParent.getBoundingClientRect();
                        this.pdfViewerBase.drawSignatureWithTool = true;
                        if (target.nextSibling && target.nextSibling.id.indexOf('initial') !== -1) {
                            this.pdfViewer.isInitialFieldToolbarSelection = true;
                        }
                    }
                    let currentValue = value ? value : this.pdfViewerBase.signatureModule.outputString;
                    if (signatureType === 'Path' && !this.pdfViewer.drawing.isPasted && !this.pdfViewer.annotation.isUndoAction) {
                        if (value && this.pdfViewerBase.signatureModule.outputString === '' && (typeof value === 'string' && value.trim().startsWith('['))) {
                            const parsenew = JSON.parse(currentValue);
                            const newArray = splitArrayCollection(parsenew);
                            currentValue = getPathString(newArray);
                        }
                    }
                    let currentFont = fontname ? fontname : this.pdfViewerBase.signatureModule.fontName;
                    const zoomvalue = this.pdfViewerBase.getZoomFactor();
                    const currentWidth = this.pdfViewerBase.drawSignatureWithTool ?
                        targetBounds.width / zoomvalue : parseFloat(currentField.style.width) / zoomvalue;
                    const currentHeight = this.pdfViewerBase.drawSignatureWithTool ?
                        targetBounds.height / zoomvalue : parseFloat(currentField.style.height) / zoomvalue;
                    const currentLeft = this.pdfViewerBase.drawSignatureWithTool ?
                        ((targetBounds.left - parentElementBounds.left)) / zoomvalue : parseFloat(currentField.style.left) / zoomvalue;
                    const currentTop = this.pdfViewerBase.drawSignatureWithTool ?
                        ((targetBounds.top - parentElementBounds.top)) / zoomvalue : parseFloat(currentField.style.top) / zoomvalue;
                    const currentPage = this.pdfViewerBase.drawSignatureWithTool ? target.nextElementSibling ? parseFloat(target.nextElementSibling.id.split('_')[1]) : parseFloat(currentField.id.split('_')[1]) : parseFloat(currentField.id.split('_')[1]);
                    const currentIndex = this.pdfViewerBase.drawSignatureWithTool ? target.nextElementSibling ? parseFloat(target.nextElementSibling.id.split('_')[2]) : parseFloat(currentField.id.split('_')[2]) : parseFloat(currentField.id.split('_')[2]);
                    let signString = this.pdfViewerBase.signatureModule.saveImageString;
                    let signatureFontFamily;
                    let signatureFontSize;
                    let rotateAngleString = currentField.offsetParent.offsetParent.style.transform ?
                        currentField.offsetParent.offsetParent.style.transform : currentField.style.transform;
                    rotateAngleString = rotateAngleString.substring(rotateAngleString.indexOf('(') + 1, rotateAngleString.indexOf('d'));
                    const rotateAngle = rotateAngleString ? parseInt(rotateAngleString, 10) : 0;
                    if (signatureType === 'Type' || signatureType === 'Text') {
                        if (!currentFont) {
                            currentFont = 'Helvetica';
                        }
                        bounds = this.getSignBounds(currentIndex, rotateAngle, currentPage, zoomvalue, currentLeft, currentTop, currentWidth, currentHeight);
                        if (this.pdfViewer.signatureFitMode === 'Default') {
                            bounds = this.getDefaultBoundsforSign(bounds);
                        }
                        annot = {
                            id: currentField.id, bounds: { x: bounds.x, y: bounds.y, width: bounds.width, height: bounds.height }, pageIndex: currentPage, data: currentValue, modifiedDate: '',
                            shapeAnnotationType: 'SignatureText', opacity: 1, rotateAngle: rotateAngle, annotName: 'SignatureText', comments: [], review: { state: '', stateModel: '', modifiedDate: '', author: '' }, fontFamily: currentFont, fontSize: bounds.height / this.signatureFontSizeConstent
                        };
                        if (annot.shapeAnnotationType === 'SignatureText') {
                            const textWidth = this.pdfViewerBase.getTextWidth(annot.data, annot.fontSize, annot.fontFamily);
                            let widthRatio = 1;
                            if (textWidth > bounds.width) {
                                widthRatio = bounds.width / textWidth;
                            }
                            annot.fontSize = this.pdfViewerBase.getFontSize(Math.floor((annot.fontSize * widthRatio)));
                        }
                        signString = annot.data;
                        signatureFontFamily = annot.fontFamily;
                        signatureFontSize = annot.fontSize;
                    }
                    else if (signatureType === 'Image') {
                        bounds = this.getSignBounds(currentIndex, rotateAngle, currentPage, zoomvalue, currentLeft, currentTop, currentWidth, currentHeight);
                        const newBounds = Object.freeze(bounds);
                        const image = new Image();
                        const currentTarget = target;
                        image.src = currentValue;
                        image.onload = function () {
                            const editableBounds = Object.isFrozen(newBounds) ? Object.assign({}, newBounds) : newBounds;
                            proxy.imageOnLoad(editableBounds, image, currentValue, currentPage, rotateAngle, currentField, signatureField, signString, signatureFontFamily, signatureFontSize, currentTarget);
                        };
                    }
                    else {
                        if ((currentValue.indexOf('base64')) !== -1) {
                            bounds = this.getSignBounds(currentIndex, rotateAngle, currentPage, zoomvalue, currentLeft, currentTop, currentWidth, currentHeight);
                            if (this.pdfViewer.signatureFitMode === 'Default') {
                                bounds = this.getDefaultBoundsforSign(bounds);
                            }
                            annot = {
                                id: currentField.id, bounds: { x: bounds.x, y: bounds.y, width: bounds.width, height: bounds.height }, pageIndex: currentPage, data: currentValue, modifiedDate: '',
                                shapeAnnotationType: 'SignatureImage', opacity: 1, rotateAngle: rotateAngle, annotName: 'SignatureField', comments: [], review: { state: '', stateModel: '', modifiedDate: '', author: '' }
                            };
                            signString = annot.data;
                        }
                        else {
                            if (!isNullOrUndefined(signBounds)) {
                                bounds = signBounds;
                            }
                            else if (this.pdfViewer.signatureFitMode === 'Default') {
                                const signatureBounds = this.pdfViewerBase.signatureModule.
                                    updateSignatureAspectRatio(currentValue, false, currentField);
                                bounds = this.getSignBounds(currentIndex, rotateAngle, currentPage, zoomvalue, currentLeft, currentTop, signatureBounds.width, signatureBounds.height, true);
                                bounds.x = bounds.x + signatureBounds.left;
                                bounds.y = bounds.y + signatureBounds.top;
                            }
                            else {
                                bounds = this.getSignBounds(currentIndex, rotateAngle, currentPage, zoomvalue, currentLeft, currentTop, currentWidth, currentHeight);
                            }
                            annot = {
                                id: currentField.id, bounds: { x: bounds.x, y: bounds.y, width: bounds.width, height: bounds.height }, pageIndex: currentPage, data: currentValue, modifiedDate: '',
                                shapeAnnotationType: 'Path', opacity: 1, rotateAngle: rotateAngle, annotName: 'SignatureField', comments: [], review: { state: '', stateModel: '', modifiedDate: '', author: '' }
                            };
                        }
                    }
                    if (this.pdfViewerBase.drawSignatureWithTool && signatureField && signatureType !== 'Image') {
                        annot.id = signatureField.id + '_content';
                        const obj = this.pdfViewer.add(annot);
                        if (signatureField.wrapper.children[1] && obj.wrapper.id === signatureField.wrapper.children[1].id) {
                            if (!isNullOrUndefined(signatureField.wrapper.children[1]) && signatureField.wrapper.children[1].relativeMode === 'Point') {
                                signatureField.wrapper.children.splice(1, 1);
                            }
                        }
                        signatureField.wrapper.children.push(obj.wrapper);
                    }
                    else if (signatureType !== 'Image') {
                        this.pdfViewer.add(annot);
                    }
                    if (annot && annot.shapeAnnotationType === 'Path' && currentValue !== '') {
                        this.pdfViewerBase.currentSignatureAnnot = annot;
                        const position = { currentHeight: currentHeight, currentWidth: currentWidth,
                            currentLeft: currentLeft, currentTop: currentTop };
                        this.pdfViewerBase.signatureModule.addSignatureCollection(bounds, position);
                        signString = this.pdfViewerBase.signatureModule.saveImageString;
                        this.pdfViewerBase.currentSignatureAnnot = null;
                    }
                    if (signatureType !== 'Image') {
                        const canvass = this.pdfViewerBase.getAnnotationCanvas('_annotationCanvas_', currentPage);
                        this.pdfViewer.renderDrawing(canvass, currentPage);
                        this.pdfViewerBase.signatureModule.showSignatureDialog(false);
                        if (currentField.className === 'e-pdfviewer-signatureformfields e-pv-signature-focus') {
                            currentField.className = 'e-pdfviewer-signatureformfields-signature e-pv-signature-focus';
                        }
                        else {
                            currentField.className = 'e-pdfviewer-signatureformfields-signature';
                        }
                        if (this.pdfViewerBase.drawSignatureWithTool && signatureField) {
                            const key = target.offsetParent.offsetParent.id.split('_')[0] + '_content';
                            annot.bounds = { x: bounds.x * zoomvalue, y: bounds.y * zoomvalue,
                                width: bounds.width * zoomvalue, height: bounds.height * zoomvalue };
                            this.updateSignatureDataInSession(annot, key);
                        }
                        else {
                            this.updateDataInSession(currentField, annot.data, annot.bounds, signatureFontFamily, signatureFontSize);
                        }
                        currentField.style.pointerEvents = 'none';
                        if (this.pdfViewer.annotation && !this.pdfViewer.annotation.isUndoActionImageLoad) {
                            this.pdfViewer.annotation.addAction(annot.pageIndex, null, annot, 'FormField Value Change', '', annot, annot);
                        }
                        if (annot.shapeAnnotationType === 'Path' || annot.shapeAnnotationType === 'SignatureText') {
                            this.pdfViewer.fireSignatureAdd(annot.pageIndex, annot.id, annot.shapeAnnotationType, annot.bounds, annot.opacity, null, null, signString);
                        }
                        this.pdfViewer.fireFocusOutFormField(currentField.name, currentValue);
                        if (this.pdfViewer.annotation) {
                            this.pdfViewer.annotation.isUndoActionImageLoad = false;
                        }
                    }
                }
            }
        }
        if (signatureType !== 'Image') {
            this.pdfViewerBase.signatureModule.hideSignaturePanel();
            this.pdfViewerBase.drawSignatureWithTool = false;
            this.pdfViewer.isInitialFieldToolbarSelection = false;
        }
    }
    //  EJ2-62918- Image signature width is wrong while adding programmatically and it is fixed by adding an onload event.
    //  A function was added and it was called
    imageOnLoad(bounds, image, currentValue, currentPage, rotateAngle, currentField, signatureField, signString, signatureFontFamily, signatureFontSize, target) {
        if (target && target.offsetParent && signatureField) {
            this.pdfViewerBase.drawSignatureWithTool = true;
            if (target.nextSibling && target.nextSibling.id.indexOf('initial') !== -1) {
                this.pdfViewer.isInitialFieldToolbarSelection = true;
            }
        }
        if (this.pdfViewer.signatureFitMode === 'Default') {
            const padding = Math.min(bounds.height / this.paddingDifferenceValue, bounds.width / this.paddingDifferenceValue);
            const maxHeight = bounds.height - padding;
            const maxWidth = bounds.width - padding;
            const imageWidth = image.width;
            const imageHeight = image.height;
            const beforeWidth = bounds.width;
            const beforeHeight = bounds.height;
            const ratio = Math.min(maxWidth / imageWidth, maxHeight / imageHeight);
            bounds.width = imageWidth * ratio;
            bounds.height = imageHeight * ratio;
            bounds.x = bounds.x + (beforeWidth - bounds.width) / 2;
            bounds.y = bounds.y + (beforeHeight - bounds.height) / 2;
        }
        const annot = {
            id: currentField.id, bounds: { x: bounds.x, y: bounds.y, width: bounds.width, height: bounds.height }, pageIndex: currentPage, data: currentValue, modifiedDate: '',
            shapeAnnotationType: 'SignatureImage', opacity: 1, rotateAngle: rotateAngle, annotName: 'SignatureField', comments: [], review: { state: '', stateModel: '', modifiedDate: '', author: '' }
        };
        signString = annot.data;
        if (this.pdfViewerBase.drawSignatureWithTool && signatureField) {
            annot.id = signatureField.id + '_content';
            const obj = this.pdfViewer.add(annot);
            if (signatureField.wrapper.children[1] && obj.wrapper.id === signatureField.wrapper.children[1].id) {
                if (!isNullOrUndefined(signatureField.wrapper.children[1]) && signatureField.wrapper.children[1].relativeMode === 'Point') {
                    signatureField.wrapper.children.splice(1, 1);
                }
            }
            signatureField.wrapper.children.push(obj.wrapper);
        }
        else {
            this.pdfViewer.add(annot);
        }
        const canvass = this.pdfViewerBase.getAnnotationCanvas('_annotationCanvas_', currentPage);
        this.pdfViewer.renderDrawing(canvass, currentPage);
        this.pdfViewerBase.signatureModule.showSignatureDialog(false);
        if (currentField.className === 'e-pdfviewer-signatureformfields e-pv-signature-focus') {
            currentField.className = 'e-pdfviewer-signatureformfields-signature e-pv-signature-focus';
        }
        else {
            currentField.className = 'e-pdfviewer-signatureformfields-signature';
        }
        if (this.pdfViewerBase.drawSignatureWithTool && signatureField) {
            const zoomvalue = this.pdfViewerBase.getZoomFactor();
            const key = target.offsetParent.offsetParent.id.split('_')[0] + '_content';
            annot.bounds = { x: bounds.x * zoomvalue, y: bounds.y * zoomvalue, width: bounds.width * zoomvalue,
                height: bounds.height * zoomvalue };
            this.updateSignatureDataInSession(annot, key);
        }
        else {
            this.updateDataInSession(currentField, annot.data, annot.bounds, signatureFontFamily, signatureFontSize);
        }
        currentField.style.pointerEvents = 'none';
        if (this.pdfViewer.annotation && !this.pdfViewer.annotation.isUndoActionImageLoad) {
            this.pdfViewer.annotation.addAction(annot.pageIndex, null, annot, 'FormField Value Change', '', annot, annot);
        }
        if (annot.shapeAnnotationType === 'SignatureImage') {
            this.pdfViewer.fireSignatureAdd(annot.pageIndex, annot.id, annot.shapeAnnotationType, annot.bounds, annot.opacity, null, null, signString);
        }
        this.pdfViewer.fireFocusOutFormField(currentField.name, currentValue);
        this.pdfViewerBase.signatureModule.hideSignaturePanel();
        this.pdfViewerBase.drawSignatureWithTool = false;
        this.pdfViewer.isInitialFieldToolbarSelection = false;
        this.pdfViewer.annotation.isUndoActionImageLoad = false;
    }
    updateSignatureDataInSession(annot, key) {
        const data = this.pdfViewerBase.getItemFromSessionStorage('_formDesigner');
        const formFieldsData = JSON.parse(data);
        if (!isNullOrUndefined(formFieldsData)) {
            for (let i = 0; i < formFieldsData.length; i++) {
                if (formFieldsData[parseInt(i.toString(), 10)].Key === key) {
                    const formFieldIndex = this.pdfViewer.formFieldCollection.findIndex((el) => el.id === formFieldsData[parseInt(i.toString(), 10)].FormField.id.split('_')[0]);
                    if (annot.shapeAnnotationType === 'SignatureText') {
                        formFieldsData[parseInt(i.toString(), 10)].FormField.signatureType = 'Text';
                        this.pdfViewer.nameTable[`${key}`.split('_')[0]].signatureType = 'Text';
                        this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.signatureType = 'Text';
                        this.pdfViewer.nameTable[`${key}`].signatureType = 'Text';
                        formFieldsData[parseInt(i.toString(), 10)].FormField.fontFamily = annot.fontFamily === 'TimesRoman' ? 'Times New Roman' : annot.fontFamily;
                        this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.fontFamily = annot.fontFamily;
                        this.pdfViewer.nameTable[`${key}`].fontFamily = annot.fontFamily;
                        this.pdfViewer.nameTable[`${key}`.split('_')[0]].fontFamily = annot.fontFamily;
                        formFieldsData[parseInt(i.toString(), 10)].FormField.fontSize = annot.fontSize;
                        this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.fontSize = annot.fontSize;
                        this.pdfViewer.nameTable[`${key}`].fontSize = annot.fontSize;
                        this.pdfViewer.nameTable[`${key}`.split('_')[0]].fontSize = annot.fontSize;
                        if (formFieldIndex > -1) {
                            this.pdfViewer.formFieldCollection[parseInt(formFieldIndex.toString(), 10)].signatureType = 'Text';
                        }
                    }
                    else if (annot.shapeAnnotationType === 'SignatureImage') {
                        formFieldsData[parseInt(i.toString(), 10)].FormField.signatureType = 'Image';
                        formFieldsData[parseInt(i.toString(), 10)].FormField.fontFamily = 'Helvetica';
                        this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.signatureType = 'Image';
                        this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.fontFamily = 'Helvetica';
                        this.pdfViewer.nameTable[`${key}`].signatureType = 'Image';
                        if (formFieldIndex > -1) {
                            this.pdfViewer.formFieldCollection[parseInt(formFieldIndex.toString(), 10)].signatureType = 'Image';
                        }
                    }
                    else {
                        formFieldsData[parseInt(i.toString(), 10)].FormField.signatureType = 'Path';
                        this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.signatureType = 'Path';
                        this.pdfViewer.nameTable[`${key}`].signatureType = 'Path';
                        if (formFieldIndex > -1) {
                            this.pdfViewer.formFieldCollection[parseInt(formFieldIndex.toString(), 10)].signatureType = 'Path';
                        }
                    }
                    formFieldsData[parseInt(i.toString(), 10)].FormField.signatureBound = annot.bounds;
                    this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.signatureBound = annot.bounds;
                    this.pdfViewer.nameTable[`${key}`].signatureBound = annot.bounds;
                    if (formFieldIndex > -1) {
                        this.pdfViewer.formFieldCollection[parseInt(formFieldIndex.toString(), 10)].signatureBound = annot.bounds;
                    }
                    if (annot.shapeAnnotationType === 'Path') {
                        const collectionData = processPathData(annot.data);
                        const csData = splitArrayCollection(collectionData);
                        formFieldsData[parseInt(i.toString(), 10)].FormField.value = JSON.stringify(csData);
                        this.pdfViewer.nameTable[`${key}`].value = annot.data;
                        this.pdfViewer.nameTable[key.split('_')[0]].value = annot.data;
                        this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.value = JSON.stringify(csData);
                        if (formFieldIndex > -1) {
                            this.pdfViewer.formFieldCollection[parseInt(formFieldIndex.toString(), 10)].value = JSON.stringify(csData);
                        }
                    }
                    else {
                        formFieldsData[parseInt(i.toString(), 10)].FormField.value = annot.data;
                        this.pdfViewerBase.formFieldCollection[parseInt(i.toString(), 10)].FormField.value = annot.data;
                        this.pdfViewer.nameTable[key.split('_')[0]].value = annot.data;
                        this.pdfViewer.nameTable[`${key}`].value = annot.data;
                        if (formFieldIndex > -1) {
                            this.pdfViewer.formFieldCollection[parseInt(formFieldIndex.toString(), 10)].value = annot.data;
                        }
                    }
                    this.pdfViewer.formDesigner.updateFormFieldCollections(formFieldsData[parseInt(i.toString(), 10)].FormField);
                    this.pdfViewer.formDesigner.updateFormFieldPropertiesChanges('formFieldPropertiesChange', formFieldsData[parseInt(i.toString(), 10)].FormField, true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, '', formFieldsData[parseInt(i.toString(), 10)].FormField.value);
                }
                if (formFieldsData[parseInt(i.toString(), 10)].Key === annot.id) {
                    formFieldsData[parseInt(i.toString(), 10)].FormField.signatureBound = annot.bounds;
                }
            }
        }
        this.pdfViewerBase.setItemInSessionStorage(formFieldsData, '_formDesigner');
    }
    /**
     * @param {any} bounds - It describes about the bounds
     * @private
     * @returns {any} - any
     */
    getDefaultBoundsforSign(bounds) {
        return { x: bounds.x + 4, y: bounds.y + 4, width: bounds.width - 8, height: bounds.height - 8 };
    }
    /**
     * @param {number} currentIndex - It describes about the current index
     * @param {number} rotateAngle - It describes about the rorate angle
     * @param {number} currentPage - It describes about the current page
     * @param {number} zoomvalue - It describes about the zoom value
     * @param {number} currentLeft - It describes about the current left
     * @param {number} currentTop - It describes about the current top
     * @param {number} currentWidth - It describes about the current width
     * @param {number} currentHeight - It describes about the current height
     * @param {boolean} isDraw - It describes about the isDraw
     * @private
     * @returns {any} - any
     */
    getSignBounds(currentIndex, rotateAngle, currentPage, zoomvalue, currentLeft, currentTop, currentWidth, currentHeight, isDraw) {
        let bounds;
        const signatureId = this.pdfViewer.isInitialFieldToolbarSelection ? 'initialIcon' : 'signIcon';
        const signIcon = document.getElementById(signatureId + '_' + currentPage + '_' + currentIndex);
        const signLeft = signIcon ? parseFloat(signIcon.style.left) * zoomvalue : 0;
        let difference = (currentLeft * zoomvalue) - (signLeft / zoomvalue);
        if (rotateAngle === 90 || rotateAngle === 270) {
            this.rotateAngle = 0;
            if (signIcon.style.left !== '') {
                if (isDraw) {
                    return bounds = { x: currentLeft - (difference / zoomvalue) - zoomvalue,
                        y: currentTop + (difference / zoomvalue) + zoomvalue, width: currentWidth, height: currentHeight };
                }
                else {
                    return bounds = { x: currentLeft - (difference / zoomvalue) - zoomvalue,
                        y: currentTop + (difference / zoomvalue) + zoomvalue, width: currentHeight, height: currentWidth };
                }
            }
            else {
                difference = 10;
                if (isDraw) {
                    return bounds = { x: currentLeft - currentWidth, y: currentTop + currentWidth,
                        width: currentHeight, height: currentWidth };
                }
                else {
                    return bounds = { x: currentLeft - currentWidth - difference / 2, y: currentTop + currentWidth + difference,
                        width: currentHeight, height: currentWidth };
                }
            }
        }
        else {
            this.rotateAngle = 0;
            return bounds = { x: currentLeft, y: currentTop, width: currentWidth, height: currentHeight };
        }
    }
    updateSameFieldsValue(event) {
        if (this.formFieldsData) {
            for (let i = 0; i < this.formFieldsData.length; i++) {
                const currentField = this.formFieldsData[parseInt(i.toString(), 10)];
                if (event.target.name === currentField.FieldName && event.target.id !== currentField.uniqueID) {
                    const currentTarget = document.getElementById(this.formFieldsData[parseInt(i.toString(), 10)].uniqueID);
                    if (currentTarget) {
                        currentTarget.value = event.target.value;
                    }
                    else {
                        currentField.Text = event.target.value;
                        this.updateDataInSession(currentField, null, null, null, null, true);
                    }
                }
            }
        }
    }
    updateFormFieldsValue(event) {
        const currentTarget = event.target;
        let fieldIndex;
        let nextFields;
        if (currentTarget.InsertSpaces && !this.isKeyDownCheck) {
            const font = parseInt(currentTarget.style.width, 10) + (parseInt(currentTarget.style.height, 10) / 2);
            currentTarget.style.width = '' + font + 'px';
            this.isKeyDownCheck = true;
        }
        if (event.which === 9 && currentTarget && (currentTarget.className === 'e-pdfviewer-formFields' || currentTarget.className === 'e-pdfviewer-signatureformfields e-pv-signature-focus' || currentTarget.className === 'e-pdfviewer-signatureformfields-signature')) {
            const id = currentTarget.id.split('input_')[1].split('_')[0];
            const textLayer = document.getElementById(this.pdfViewer.element.id + '_textLayer_' + parseInt(id, 10));
            const currentFields = textLayer.getElementsByClassName('e-pdfviewer-formFields');
            let istabindexed = true;
            fieldIndex = this.pdfViewer.formFieldCollections.findIndex((field) => field.id === currentTarget.id);
            if ((!event.shiftKey && event.key === 'Tab')) {
                nextFields = fieldIndex + 1 < this.pdfViewer.formFieldCollections.length ?
                    this.pdfViewer.formFieldCollections[fieldIndex + 1] : this.pdfViewer.formFieldCollections[0];
            }
            this.pdfViewer.focusFormField(nextFields);
            istabindexed = true;
            event.preventDefault();
            let tabindex = currentTarget.tabIndex + 1;
            while (!istabindexed) {
                for (let l = 0; l < currentFields.length; l++) {
                    istabindexed = false;
                    if (currentFields[parseInt(l.toString(), 10)].tabIndex === (tabindex)) {
                        currentFields[parseInt(l.toString(), 10)].focus();
                        istabindexed = true;
                        event.preventDefault();
                        break;
                    }
                }
                if (this.maintainTabIndex[`${id}`] === tabindex) {
                    istabindexed = true;
                }
                tabindex = tabindex + 1;
            }
        }
        if ((event.shiftKey && event.key === 'Tab')) {
            const fieldIndex = this.pdfViewer.formFieldCollections.findIndex((field) => field.id === currentTarget.id);
            const nextField = fieldIndex > 0 ? this.pdfViewer.formFieldCollections[fieldIndex - 1] :
                this.pdfViewer.formFieldCollections[this.pdfViewer.formFieldCollections.length - 1];
            this.pdfViewer.focusFormField(nextField);
            event.preventDefault();
        }
        if (event.currentTarget.classList.contains('e-pdfviewer-signatureformfields') ||
            event.currentTarget.classList.contains('e-pdfviewer-signatureformfields-signature')) {
            if (event.key === 'Enter') {
                const currentTarget = event.target;
                for (let m = 0; m < this.pdfViewer.formFieldCollections.length; m++) {
                    if (currentTarget.id === this.pdfViewer.formFieldCollections[parseInt(m.toString(), 10)].id) {
                        this.pdfViewerBase.signatureModule.setFocus(currentTarget.id);
                        this.pdfViewer.fireFormFieldClickEvent('formFieldClicked', this.pdfViewer.formFieldCollections[parseInt(m.toString(), 10)]);
                    }
                }
            }
            else {
                event.preventDefault();
            }
        }
    }
    changeFormFields(event) {
        const currentTarget = event.target;
        this.updateDataInSession(currentTarget);
    }
    /**
     * @param {any} target - It describes about the target
     * @param {any} signaturePath - It describes about the signature path
     * @param {any} signatureBounds - It describes about the signature bounds
     * @param {string} signatureFontFamily - It describes about the signature font family
     * @param {number} signatureFontSize   - It describes about the signature font size
     * @param {boolean} isUpdateSameField - It describes about the isUpdateSameField
     * @private
     * @returns {void}
     */
    updateDataInSession(target, signaturePath, signatureBounds, signatureFontFamily, signatureFontSize, isUpdateSameField = false) {
        this.pdfViewerBase.updateDocumentEditedProperty(true);
        let filterFields = [];
        let fieldsByName = ' ';
        let filterFieldName = [];
        let filterArrayLength = 0;
        const data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
        if (data && !this.pdfViewer.formDesignerModule) {
            const FormFieldsData = JSON.parse(data);
            filterFields = FormFieldsData.filter((item) => item.uniqueID === target.id);
            if (filterFields.length > 0) {
                fieldsByName = filterFields[0].FieldName;
                filterFieldName = FormFieldsData.filter((item) => item.FieldName === fieldsByName);
                filterArrayLength = filterFieldName.length;
            }
            for (let m = 0; m < FormFieldsData.length; m++) {
                const currentData = FormFieldsData[parseInt(m.toString(), 10)];
                if (currentData.uniqueID === target.id || fieldsByName === currentData.FieldName) {
                    if (target && target.type === 'text' || target.type === 'password' || target.type === 'textarea') {
                        const signField = target;
                        if (signField.classList.contains('e-pdfviewer-signatureformfields') || signField.classList.contains('e-pdfviewer-signatureformfields-signature')) {
                            if (signaturePath) {
                                currentData.Value = signaturePath;
                            }
                            if (signatureBounds) {
                                if (!isNullOrUndefined(currentData.uniqueID) && fieldsByName === currentData.FieldName
                                    && target.id === currentData.uniqueID) {
                                    currentData.Bounds = signatureBounds;
                                }
                                else {
                                    const boundWidth = this.ConvertPointToPixel(currentData.LineBounds.Width);
                                    const boundHeight = this.ConvertPointToPixel(currentData.LineBounds.Height);
                                    const boundX = this.ConvertPointToPixel(currentData.LineBounds.X);
                                    const boundY = this.ConvertPointToPixel(currentData.LineBounds.Y);
                                    const currentHeight = signatureBounds.height;
                                    const currenWidth = signatureBounds.width;
                                    const newX = boundX + ((boundWidth - currenWidth) / 2);
                                    const newY = boundY + ((boundHeight - currentHeight) / 2);
                                    currentData.Bounds = { x: newX, y: newY, height: currentHeight, width: currenWidth };
                                }
                            }
                            if (signatureFontFamily) {
                                currentData.FontFamily = signatureFontFamily;
                                currentData.FontSize = signatureFontSize;
                            }
                        }
                        else {
                            currentData.Text = target.value;
                            currentData.Value = target.value;
                            if (!isNullOrUndefined(target.multiline)) {
                                currentData.Multiline = target.multiline;
                            }
                        }
                    }
                    else if (target.type === 'radio') {
                        if (currentData.uniqueID === target.id) {
                            const targetRadioButton = target.id;
                            const filterRadioButtonSameName = FormFieldsData.filter((sameNameRadioButtonField) => (sameNameRadioButtonField.GroupName === target.name) && sameNameRadioButtonField.Name === 'RadioButton');
                            for (let l = 0; l < filterRadioButtonSameName.length; l++) {
                                const currentType = filterRadioButtonSameName[parseInt(l.toString(), 10)];
                                if (currentType.uniqueID !== targetRadioButton) {
                                    currentType.Selected = false;
                                }
                                const currentTarget = document.getElementById(currentType.uniqueID);
                                if (currentTarget) {
                                    if (targetRadioButton !== currentTarget.id) {
                                        currentTarget.Selected = false;
                                    }
                                }
                            }
                            if (currentData.Value === '' || currentData.Value !== target.value) {
                                currentData.Value = target.value;
                            }
                            if (target.value === currentData.Value || target.id === currentData.uniqueID) {
                                currentData.Selected = true;
                                break;
                            }
                            else {
                                currentData.Selected = false;
                            }
                        }
                    }
                    else if (target.type === 'checkbox') {
                        const targetCheckBox = target.id;
                        const filterCheckBoxSameName = FormFieldsData.filter((sameNameCheckboxField) => (sameNameCheckboxField.GroupName === target.name) && sameNameCheckboxField.Name === 'CheckBox');
                        for (let l = 0; l < filterCheckBoxSameName.length; l++) {
                            const currentType = filterCheckBoxSameName[parseInt(l.toString(), 10)];
                            if (currentType.uniqueID !== targetCheckBox) {
                                currentType.Selected = false;
                                currentType.checked = false;
                            }
                            const currentTarget = document.getElementById(currentType.uniqueID);
                            if (currentTarget) {
                                if (targetCheckBox !== currentTarget.id) {
                                    currentTarget.Selected = false;
                                    currentTarget.checked = false;
                                    currentTarget.style.webkitAppearance = 'none';
                                }
                            }
                        }
                        if (target.checked && target.id === currentData.uniqueID) {
                            currentData.Selected = true;
                        }
                        else {
                            currentData.Selected = false;
                        }
                        if (currentData.Value === '') {
                            currentData.Value = target.value;
                        }
                    }
                    else if (target.type === 'select-one' && target.size === 0) {
                        if (target.selectedIndex < 0) {
                            target.selectedIndex = currentData.selectedIndex;
                        }
                        const currentValue = target.options[target.selectedIndex].text;
                        const childrens = target.children;
                        for (let k = 0; k < childrens.length; k++) {
                            if (childrens[parseInt(k.toString(), 10)].text === currentValue) {
                                currentData.SelectedValue = currentValue;
                                currentData.selectedIndex = target.selectedIndex;
                            }
                        }
                    }
                    else if (target.type === 'select-multiple' || target.size > 0) {
                        const currentValue = target.selectedOptions;
                        currentData.SelectedList = [];
                        for (let z = 0; z < currentValue.length; z++) {
                            const childrens = target.children;
                            for (let k = 0; k < childrens.length; k++) {
                                if (childrens[parseInt(k.toString(), 10)] === currentValue[parseInt(z.toString(), 10)]) {
                                    currentData.SelectedList.push(k);
                                }
                            }
                        }
                        currentData.SelectedValue = target.value;
                        const index = currentData.TextList ? currentData.TextList.indexOf(target.value) : 0;
                        currentData.selectedIndex = index > -1 ? index : 0;
                        currentData.SelectedList = [currentData.selectedIndex];
                    }
                    if (target.disabled) {
                        currentData.IsReadonly = true;
                    }
                    currentData.IsRequired = target.Required ? target.Required : (target.required ? target.required : false);
                    currentData.ToolTip = target.tooltip ? target.tooltip : '';
                    this.updateFormFieldsCollection(currentData);
                    filterArrayLength--;
                    if (filterArrayLength === 0) {
                        break;
                    }
                }
                else if (!isUpdateSameField) {
                    if (target && target.getAttribute('list') != null && target.type === 'text' && currentData.uniqueID === target.list.id) {
                        currentData.SelectedValue = target.value;
                    }
                }
                else if (isUpdateSameField) {
                    currentData.SelectedValue = target.Text;
                }
                this.updateFormFieldsCollection(currentData);
            }
            PdfViewerBase.sessionStorageManager.removeItem(this.pdfViewerBase.documentId + '_formfields');
            this.pdfViewerBase.setItemInSessionStorage(FormFieldsData, '_formfields');
        }
        if (this.pdfViewer.formDesignerModule && target && target.id) {
            const selectedItem = this.pdfViewer.nameTable[target.id.split('_')[0]];
            if (selectedItem && selectedItem.wrapper && selectedItem.wrapper.children[0]) {
                selectedItem.value = target.value;
                const point = cornersPointsBeforeRotation(selectedItem.wrapper.children[0]).topLeft;
                this.pdfViewer.formDesignerModule.
                    updateFormDesignerFieldInSessionStorage(point, selectedItem.wrapper.children[0], selectedItem.formFieldAnnotationType, selectedItem);
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    removeExistingFormFields() {
        const data = this.pdfViewerBase.getItemFromSessionStorage('_formDesigner');
        const formFieldsData = !isNullOrUndefined(data) ? JSON.parse(data) : null;
        if (formFieldsData) {
            for (let i = 0; i < formFieldsData.length; i++) {
                if (formFieldsData[parseInt(i.toString(), 10)].FormField.formFieldAnnotationType === 'RadioButton') {
                    let buttonItem = [];
                    buttonItem = formFieldsData[parseInt(i.toString(), 10)].FormField.radiobuttonItem;
                    const sameButtonItemId = formFieldsData[parseInt(i.toString(), 10)].FormField.id.split('_')[0];
                    for (let j = 0; j < buttonItem.length; j++) {
                        const otherButton = buttonItem[parseInt(j.toString(), 10)];
                        if (otherButton.id.split('_')[0] !== sameButtonItemId) {
                            this.pdfViewer.formDesignerModule.deleteFormField(otherButton.id.split('_')[0]);
                        }
                    }
                }
                if (formFieldsData[parseInt(i.toString(), 10)].Key) {
                    this.pdfViewer.formDesignerModule.deleteFormField(formFieldsData[parseInt(i.toString(), 10)].Key.split('_')[0]);
                }
            }
        }
    }
    applyCommonProperties(inputdiv, pageIndex, index, currentData, isFieldRotated) {
        const inputField = document.getElementById(this.pdfViewer.element.id + 'input_' + pageIndex + '_' + index);
        if (inputField) {
            const textLayer = document.getElementById(this.pdfViewer.element.id + '_textLayer_' + pageIndex);
            if ((inputdiv.type === 'text' || inputdiv.type === 'password' || inputdiv.type === 'textarea') &&
                inputField.parentElement !== textLayer) {
                inputField.parentElement.remove();
            }
            if (!(inputField.className === 'e-pdfviewer-signatureformfields e-pv-signature-focus')) {
                inputField.remove();
            }
        }
        const signIcon = document.getElementById('signIcon_' + pageIndex + '_' + index);
        const left = parseFloat(inputdiv.style.left);
        const top = parseInt(inputdiv.style.top, 10);
        const width = parseFloat(inputdiv.style.width);
        const height = parseFloat(inputdiv.style.height);
        let signIconWidth;
        let signIconHeght;
        let hightDifference;
        let widthDifference;
        const zoomvalue = this.pdfViewerBase.getZoomFactor();
        if (signIcon && !isFieldRotated) {
            signIconWidth = parseFloat(signIcon.style.width);
            signIconHeght = parseFloat(signIcon.style.height);
            if (signIcon.style.transform === 'rotate(90deg)') {
                signIcon.style.transform = 'rotate(0deg)';
                hightDifference = height / 2;
                widthDifference = signIconWidth * zoomvalue;
                signIcon.style.left = ((left - (hightDifference - (signIconWidth * zoomvalue))) + (widthDifference / 2)) + 'px';
            }
            if (signIcon.style.transform === 'rotate(180deg)') {
                signIcon.style.transform = 'rotate(0deg)';
                signIcon.style.left = left + 'px';
                signIcon.style.top = (top) + 'px';
            }
            if (signIcon.style.transform === 'rotate(270deg)') {
                signIcon.style.transform = 'rotate(0deg)';
                hightDifference = height / 2;
                widthDifference = signIconWidth * zoomvalue;
                signIcon.style.left = ((left - (hightDifference - widthDifference)) + (widthDifference / 2)) + 'px';
                signIcon.style.top = (top) + 'px';
            }
        }
        if (currentData.IsSignatureField && this.isSignatureField) {
            inputdiv.className = 'e-pdfviewer-signatureformfields-signature';
            inputdiv.style.pointerEvents = 'none';
        }
        else if (currentData.IsSignatureField) {
            if (currentData.Value) {
                inputdiv.className = 'e-pdfviewer-signatureformfields-signature';
                inputdiv.style.pointerEvents = 'none';
            }
            else {
                inputdiv.className = 'e-pdfviewer-signatureformfields';
            }
        }
        else if (currentData.Name !== 'Button') {
            inputdiv.className = 'e-pdfviewer-formFields';
        }
        inputdiv.id = this.pdfViewer.element.id + 'input_' + pageIndex + '_' + index;
        inputdiv.ariaLabel = this.pdfViewer.element.id + 'input_' + pageIndex;
        inputdiv.style.zIndex = 1000;
    }
    /**
     * @param {any} currentData - It describes about the current data
     * @param {number} pageIndex - It describes about the page index
     * @param {number} index - It describes about the index
     * @param {any} printContainer - It describes about the print container
     * @param {number} count - It describes about the count
     * @private
     * @returns {any} - any
     */
    createFormFields(currentData, pageIndex, index, printContainer, count) {
        let currentField;
        switch (currentData['Name']) {
            case 'Textbox':
                currentField = this.createTextBoxField(currentData, pageIndex, 'text');
                break;
            case 'Password':
                currentField = this.createTextBoxField(currentData, pageIndex, 'password');
                break;
            case 'RadioButton':
                currentField = this.createRadioBoxField(currentData, pageIndex, 'radio');
                break;
            case 'CheckBox':
                currentField = this.createRadioBoxField(currentData, pageIndex, 'checkbox', printContainer);
                break;
            case 'DropDown':
                currentField = this.createDropDownField(currentData, pageIndex, index, printContainer);
                break;
            case 'ListBox':
                currentField = this.createListBoxField(currentData, pageIndex);
                break;
            case 'InitialField':
            case 'SignatureField': {
                currentField = this.createSignatureField(currentData, pageIndex, index, printContainer, count);
                let isFieldRotated = false;
                if (currentData['Rotation'] === 0) {
                    isFieldRotated = true;
                }
                if (currentData.Value && currentData.Value !== '') {
                    this.renderExistingAnnnot(currentData, index, printContainer, isFieldRotated);
                    this.isSignatureRendered = true;
                    count++;
                }
                break;
            }
            case 'Button':
                currentField = this.createButtonField(currentData, pageIndex);
                break;
            case 'ink':
                if (this.pdfViewer.formDesignerModule) {
                    if (currentData.Value && currentData.Value !== '' && !this.isSignatureRendered) {
                        this.renderExistingAnnnot(currentData, index, printContainer);
                    }
                }
                break;
            case 'SignatureText':
            case 'SignatureImage':
                if (currentData.Value && currentData.Value !== '' && !this.isSignatureRendered) {
                    this.renderExistingAnnnot(currentData, index, printContainer);
                }
                break;
        }
        return { currentField, count };
    }
    getFormFieldType(currentData) {
        let currentField;
        switch (currentData['Name']) {
            case 'Textbox':
                currentField = 'Textbox';
                break;
            case 'Password':
                currentField = 'Password';
                break;
            case 'RadioButton':
                currentField = 'RadioButton';
                break;
            case 'CheckBox':
                currentField = 'CheckBox';
                break;
            case 'DropDown':
                currentField = 'DropDown';
                break;
            case 'ListBox':
                currentField = 'ListBox';
                break;
            case 'SignatureField':
                currentField = 'SignatureField';
                if (currentData.IsInitialField) {
                    currentField = 'InitialField';
                }
                break;
            case 'InitialField':
                currentField = 'InitialField';
                break;
        }
        return currentField;
    }
    createButtonField(data, pageIndex) {
        const inputField = document.createElement('input');
        if (data.Value && (this.isBase64(data.Value) || this.isURL(data.Value))) {
            inputField.type = 'image';
            inputField.src = data.Value;
        }
        else {
            inputField.type = 'button';
        }
        inputField.className = 'e-pv-buttonItem';
        if (data.Text !== '') {
            inputField.value = data.Text;
        }
        else {
            inputField.value = '';
        }
        inputField.name = data.FieldName;
        return inputField;
    }
    /**
     * Returns the boolean value based on the imgae source base64
     *
     * @param {string} imageSrc - Passing the image source.
     * @returns {boolean} - boolean
     */
    isBase64(imageSrc) {
        return /^data:([a-zA-Z]*\/[a-zA-Z+.-]*);base64,/.test(imageSrc);
    }
    /**
     * Returns the boolean value based on the imgae source URL
     *
     * @param {string} imageSrc - Passing the image source.
     * @returns {boolean} - boolean
     */
    isURL(imageSrc) {
        try {
            new URL(imageSrc);
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    createTextBoxField(data, pageIndex, type) {
        let inputField;
        if (data.Visible === 1) {
            return;
        }
        if (data.Multiline) {
            inputField = document.createElement('textarea');
            inputField.style.resize = 'none';
        }
        else {
            inputField = document.createElement('input');
            inputField.type = type;
        }
        if (data.MaxLength > 0) {
            inputField.maxLength = data.MaxLength;
        }
        this.addAlignmentPropety(data, inputField);
        if (data.Text !== '') {
            inputField.value = data.Text;
        }
        else {
            inputField.value = '';
        }
        if (!this.pdfViewer.enableAutoComplete) {
            inputField.autocomplete = 'off';
        }
        inputField.name = data.FieldName;
        return inputField;
    }
    checkIsReadonly(data, inputField) {
        let isReadonly = false;
        for (let n = 0; n < this.readOnlyCollection.length; n++) {
            if (inputField.id === this.readOnlyCollection[parseInt(n.toString(), 10)]) {
                isReadonly = true;
                break;
            }
        }
        if (!this.pdfViewer.formDesignerModule && !this.pdfViewer.annotationModule && (data.IsInitialField || data.IsSignatureField)) {
            isReadonly = true;
        }
        if (data.IsReadonly || (!this.pdfViewer.enableFormFields) || isReadonly) {
            inputField.disabled = true;
            inputField.style.cursor = 'default';
            inputField.style.backgroundColor = 'transparent';
        }
        else {
            const borderColor = data.BackColor;
            if (data.Name !== 'Button') {
                inputField.style.backgroundColor = 'rgba(' + borderColor.R + ',' + borderColor.G + ',' + borderColor.B + ',' + 0.2 + ')';
            }
            else {
                const opacity = data.Opacity;
                if (opacity) {
                    inputField.style.backgroundColor = 'rgba(' + borderColor.R + ',' + borderColor.G + ',' + borderColor.B + ',' + opacity + ')';
                }
                else {
                    inputField.style.backgroundColor = 'rgb(' + borderColor.R + ',' + borderColor.G + ',' + borderColor.B + ')';
                }
            }
            const fontColor = data.FontColor;
            inputField.style.color = 'rgba(' + fontColor.R + ',' + fontColor.G + ',' + fontColor.B + ',' + 1 + ')';
        }
    }
    /**
     * @param {boolean} isReadonly - It describes about the isReadOnly value
     * @private
     * @returns {void}
     */
    formFieldsReadOnly(isReadonly) {
        const formFields = document.getElementsByClassName('e-pdfviewer-formFields');
        this.makeformFieldsReadonly(formFields, isReadonly);
        const signatureFields = document.getElementsByClassName('e-pdfviewer-signatureformfields');
        this.makeformFieldsReadonly(signatureFields, isReadonly);
    }
    makeformFieldsReadonly(formFields, isReadonly) {
        for (let i = 0; i < formFields.length; i++) {
            if (formFields[parseInt(i.toString(), 10)]) {
                const inputField = formFields[parseInt(i.toString(), 10)];
                if (!isReadonly) {
                    inputField.disabled = true;
                    inputField.style.cursor = 'default';
                }
                else {
                    inputField.disabled = false;
                }
            }
        }
    }
    applyTabIndex(data, inputField, pageIndex) {
        inputField.tabIndex = data.TabIndex;
        this.maxTabIndex = Math.max(this.maxTabIndex, inputField.tabIndex);
        if (this.minTabIndex === -1) {
            this.minTabIndex = inputField.tabIndex;
        }
        this.minTabIndex = Math.min(this.minTabIndex, inputField.tabIndex);
        this.maintainTabIndex[pageIndex.toString()] = this.maxTabIndex;
        this.maintanMinTabindex[pageIndex.toString()] = this.minTabIndex;
    }
    checkIsRequiredField(data, inputField) {
        if (data.IsRequired) {
            inputField.required = true;
            inputField.style.border = '1px solid red';
        }
        else {
            const borderColor = data.BorderColor;
            inputField.style.border = data.BorderWidth;
            inputField.style.borderColor = 'rgba(' + borderColor.R + ',' + borderColor.G + ',' + borderColor.B + ',' + 1 + ')';
        }
        if (inputField.type !== 'checkbox' && inputField.type !== 'radio') {
            const borderStyle = data.BorderStyle;
            this.addBorderStylePropety(borderStyle, inputField);
        }
    }
    applyDefaultColor(inputField) {
        if (inputField.type !== 'button' && (inputField.style.backgroundColor === 'rgba(255, 255, 255, 0.2)' || inputField.style.backgroundColor === 'rgba(0, 0, 0, 0.2)') || inputField.style.backgroundColor === 'rgba(218, 234, 247, 0.2)') {
            inputField.style.backgroundColor = 'rgba(0, 20, 200, 0.2)';
        }
        if (inputField.style.color === 'rgba(255, 255, 255, 0.2)') {
            inputField.style.color = 'black';
        }
    }
    addAlignmentPropety(data, inputField) {
        const alignment = data.Alignment;
        switch (alignment) {
            case 0:
                inputField.style.textAlign = 'left';
                break;
            case 1:
                inputField.style.textAlign = 'center';
                break;
            case 2:
                inputField.style.textAlign = 'right';
                break;
            case 3:
                inputField.style.textAlign = 'justify';
                break;
        }
    }
    addBorderStylePropety(borderStyle, inputField) {
        switch (borderStyle) {
            case 0:
                inputField.style.borderStyle = 'solid';
                break;
            case 1:
                inputField.style.borderStyle = 'dashed';
                break;
            case 2:
                inputField.style.borderStyle = 'outset';
                break;
            case 3:
                inputField.style.borderStyle = 'inset';
                break;
            case 4:
                inputField.style.borderStyle = 'outset';
                break;
            case 5:
                inputField.style.borderStyle = 'dotted';
                break;
            case 6:
                inputField.style.borderStyle = 'inset';
                break;
        }
    }
    createRadioBoxField(data, pageIndex, type, printContainer) {
        const inputField = document.createElement('input');
        inputField.type = type;
        if (data.Selected) {
            inputField.checked = true;
        }
        else if (type === 'checkbox' && !printContainer) {
            inputField.style.webkitAppearance = 'none';
        }
        inputField.name = data.GroupName;
        inputField.value = data.Value;
        return inputField;
    }
    createDropDownField(data, pageIndex, index, printContainer) {
        let inputField = document.createElement('select');
        const childItems = (data.Name === 'DropDown') ? data['ComboBoxList'] : data['TextList'];
        if (data.Selected && !printContainer) {
            const previousField = document.getElementById('editableDropdown' + pageIndex + '_' + index);
            if (previousField) {
                previousField.remove();
            }
            const inputFields = document.createElement('input');
            inputFields.id = 'editableDropdown' + pageIndex + '_' + index;
            inputFields.setAttribute('list', this.pdfViewer.element.id + 'input_' + pageIndex + '_' + index);
            const bounds = data['LineBounds'];
            const font = data['Font'];
            inputFields.style.position = 'absolute';
            inputFields.style.border = '0px';
            this.applyPosition(inputFields, bounds, font, pageIndex, data['Rotation']);
            inputFields.style.backgroundColor = 'rgba(0, 20, 200, 0.2)';
            inputFields.className = 'e-pdfviewer-formFields';
            if (data.selectedIndex === -1) {
                inputFields.value = data.SelectedValue;
            }
            if (printContainer) {
                printContainer.appendChild(inputFields);
            }
            else {
                const textLayer = document.getElementById(this.pdfViewer.element.id + '_textLayer_' + pageIndex);
                textLayer.appendChild(inputFields);
            }
            inputFields.addEventListener('focus', this.focusFormFields.bind(this));
            inputFields.addEventListener('blur', this.blurFormFields.bind(this));
            inputFields.addEventListener('click', this.updateFormFields.bind(this));
            inputFields.addEventListener('change', this.changeFormFields.bind(this));
            inputFields.addEventListener('keydown', this.updateFormFieldsValue.bind(this));
            inputField = document.createElement('DATALIST');
        }
        for (let j = 0; j < childItems.length; j++) {
            const option = document.createElement('option');
            option.className = 'e-dropdownSelect';
            const itemName = childItems[parseInt(j.toString(), 10)].itemName ?
                childItems[parseInt(j.toString(), 10)].itemName : childItems[parseInt(j.toString(), 10)].ItemName;
            const itemValue = childItems[parseInt(j.toString(), 10)].itemValue ?
                childItems[parseInt(j.toString(), 10)].itemValue : childItems[parseInt(j.toString(), 10)].ItemValue;
            if (data.SelectedValue === itemName || data.selectedIndex === j) {
                option.selected = true;
            }
            else {
                option.selected = false;
            }
            option.value = itemValue;
            option.innerHTML = itemName;
            inputField.appendChild(option);
        }
        inputField.name = data.Text;
        return inputField;
    }
    createListBoxField(data, pageIndex) {
        const inputField = document.createElement('select');
        const childItems = data['TextList'];
        if (data.MultiSelect) {
            inputField.multiple = true;
        }
        else {
            inputField.multiple = false;
            inputField.size = childItems.length;
        }
        for (let j = 0; j < childItems.length; j++) {
            const option = document.createElement('option');
            option.className = 'e-pdfviewer-ListBox';
            for (let k = 0; k < data.SelectedList.length; k++) {
                if (data.SelectedList[parseInt(k.toString(), 10)] === j) {
                    option.selected = true;
                }
            }
            option.innerHTML = childItems[parseInt(j.toString(), 10)];
            inputField.appendChild(option);
        }
        inputField.name = data.Text;
        return inputField;
    }
    createSignatureField(data, pageIndex, index, printContainer, count) {
        const inputField = document.createElement('input');
        inputField.type = 'text';
        inputField.name = data.FieldName;
        const zoomvalue = this.pdfViewerBase.getZoomFactor();
        const previousField = document.getElementById('signIcon_' + pageIndex + '_' + index);
        if (previousField && !printContainer) {
            previousField.remove();
        }
        this.pdfViewerBase.isInitialField = data.IsInitialField;
        const signIndicator = this.pdfViewerBase.isInitialField ? 'Initial' : 'Sign';
        //check whether the width for sign indicator has default value or not and then set the default width value for initial field.
        const signatureFieldIndicatorWidth = this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings ?
            (this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.width === 19 ?
                (this.pdfViewerBase.isInitialField ? 27 : 19) :
                this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.width) : 19;
        const span = document.createElement('span');
        const textLayer = document.getElementById(this.pdfViewer.element.id + '_textLayer_' + pageIndex);
        const bounds = data['LineBounds'];
        const left = this.ConvertPointToPixel(bounds.X);
        const top = this.ConvertPointToPixel(bounds.Y);
        const indicatorWidth = this.ConvertPointToPixel(bounds.Width);
        const indicatorHeight = this.ConvertPointToPixel(bounds.Height);
        const height = this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings ?
            (this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.height > indicatorHeight * zoomvalue / 2 ?
                indicatorHeight * zoomvalue / 2 : this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.height) :
            indicatorHeight * zoomvalue / 2;
        const width = signatureFieldIndicatorWidth > indicatorWidth * zoomvalue / 2 ? indicatorWidth * zoomvalue / 2 :
            signatureFieldIndicatorWidth;
        const size = this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings ?
            (this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.fontSize > height / 2 ? 10 :
                this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.fontSize) : 10;
        const fontSize = size > width ? width / 2 : (size > height ? height / 2 : size);
        span.style.position = 'absolute';
        span.id = 'signIcon_' + pageIndex + '_' + index;
        const rotation = this.getAngle(pageIndex);
        const annotBounds = { left: left, top: top, width: width, height: height };
        const fieldBounds = this.getBounds(annotBounds, pageIndex);
        span.style.transform = 'rotate(' + rotation + 'deg)';
        span.style.left = fieldBounds.left * zoomvalue + 'px';
        span.style.top = fieldBounds.top * zoomvalue + 'px';
        if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
            span.style.height = 5 + 'px';
            span.style.width = 10 + 'px';
            span.style.fontSize = '3px';
        }
        else {
            span.style.height = height + 'px';
            span.style.width = width + 'px';
            span.style.fontSize = fontSize + 'px';
            if (isBlazor()) {
                span.style.fontSize = (fontSize - 1) + 'px';
            }
        }
        if (!((height + this.indicatorPaddingValue) > indicatorHeight * zoomvalue) &&
            !((width + this.indicatorPaddingValue) > indicatorWidth * zoomvalue)) {
            span.style.padding = '2px';
        }
        span.style.textAlign = 'center';
        span.style.boxSizing = 'content-box';
        span.innerHTML = this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings ?
            (this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.text ?
                this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.text : signIndicator) : signIndicator;
        span.style.color = this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings ? (this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.color ? this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.color : 'black') : 'black';
        span.style.backgroundColor = this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings ? (this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.backgroundColor ? this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.backgroundColor : 'orange') : 'orange';
        span.style.opacity = this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings ?
            (this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.opacity ?
                this.pdfViewer.signatureFieldSettings.signatureIndicatorSettings.opacity : 1) : 1;
        if (!isNullOrUndefined(textLayer)) {
            textLayer.appendChild(span);
        }
        this.addSignaturePath(data, count);
        return inputField;
    }
    addSignaturePath(signData, count) {
        this.isSignatureField = false;
        const data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
        if (data) {
            let formFieldsData = JSON.parse(data);
            if (typeof formFieldsData === 'string') {
                formFieldsData = JSON.parse(formFieldsData);
            }
            for (let m = 0; m < formFieldsData.length; m++) {
                const currentData = formFieldsData[parseInt(m.toString(), 10)];
                if (currentData.ActualFieldName === null && count && (currentData.Name === 'ink' || currentData.Name === 'SignatureField' || currentData.Name === 'SignatureImage' || currentData.Name === 'SignatureText') && (this.pdfViewer.formDesigner ? ((currentData.FieldName.split('_')[0]) === (signData.ActualFieldName) || (currentData.FieldName.split('_')[0]) === (signData.FieldName)) : ((currentData.FieldName.split('_')[0] === (signData.FieldName)) && !isNullOrUndefined(signData.ActualFieldName)) && currentData.Value && currentData.Value !== '')) {
                    if (signData.PageIndex === currentData.PageIndex) {
                        signData.Value = currentData.Value;
                        signData.FontFamily = currentData.FontFamily;
                        signData.FontSize = currentData.FontSize;
                        this.isSignatureField = true;
                        signData.Bounds = currentData.LineBounds;
                    }
                }
                if (currentData.ActualFieldName === null && count && (currentData.Name === 'ink' || currentData.Name === 'SignatureField' || currentData.Name === 'SignatureImage' || currentData.Name === 'SignatureText') && this.pdfViewer.formDesigner ? currentData.FieldName === signData.ActualFieldName + '_' + count || currentData.FieldName === signData.FieldName + '_' + count : ((currentData.FieldName === signData.FieldName + '_' + count || currentData.FieldName === signData.ActualFieldName + '_' + count) && !isNullOrUndefined(signData.ActualFieldName)) && currentData.Value && currentData.Value !== '') {
                    signData.Value = currentData.Value;
                    signData.FontFamily = currentData.FontFamily;
                    signData.FontSize = currentData.FontSize;
                    this.isSignatureField = true;
                    if (!signData.Bounds) {
                        signData.Bounds = currentData.LineBounds;
                    }
                    break;
                }
            }
        }
        return this.isSignatureField;
    }
    getBounds(bound, pageIndex, rotation, isFieldRotated, data) {
        let pageDetails = this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)];
        let pageRotation = rotation;
        if (pageDetails) {
            pageRotation = pageDetails.rotation;
        }
        if (!pageDetails && data && data.pageSizes && data.pageSizes[parseInt(pageIndex.toString(), 10)]) {
            const size = data.pageSizes[parseInt(pageIndex.toString(), 10)];
            pageDetails = {
                width: size.width,
                height: size.height,
                rotation: data.pageRotation[parseInt(pageIndex.toString(), 10)],
                top: this.pdfViewerBase.pageGap
            };
            pageRotation = data.pageRotation[parseInt(pageIndex.toString(), 10)];
        }
        let bounds;
        if (pageRotation > 0) {
            bounds = this.getBoundsPosition(pageRotation, bound, pageDetails, isFieldRotated);
        }
        else {
            bounds = this.getBoundsPosition(pageRotation, bound, pageDetails, isFieldRotated);
        }
        return bounds;
    }
    getBoundsPosition(rotation, bound, pageDetails, isFieldRotated) {
        let bounds;
        if (!isFieldRotated) {
            switch (rotation) {
                case 90:
                    bounds = { left: pageDetails.width - bound.top - bound.height, top: bound.left, width: bound.height, height: bound.width };
                    break;
                case 180:
                    bounds = { left: pageDetails.width - bound.left - bound.width, top: pageDetails.height - bound.top - bound.height,
                        width: bound.width, height: bound.height };
                    break;
                case 270:
                    bounds = { left: bound.top, top: pageDetails.height - bound.left - bound.width, width: bound.height, height: bound.width };
                    break;
                case 0:
                    bounds = bound;
                    break;
                case 1:
                    bounds = { left: pageDetails.width - bound.top - bound.height, top: bound.left, width: bound.height, height: bound.width };
                    break;
                case 2:
                    bounds = { left: pageDetails.width - bound.left - bound.width, top: pageDetails.height - bound.top - bound.height,
                        width: bound.width, height: bound.height };
                    break;
                case 3:
                    bounds = { left: bound.top, top: pageDetails.height - bound.left - bound.width, width: bound.height, height: bound.width };
                    break;
            }
            if (!bounds) {
                bounds = bound;
            }
        }
        else {
            switch (rotation) {
                case 0:
                    bounds = bound;
                    break;
                case 1:
                    bounds = { left: pageDetails.width - bound.top - bound.height - (bound.width / 2 - bound.height / 2),
                        top: bound.left + (bound.width / 2 - bound.height / 2), width: bound.width, height: bound.height };
                    break;
                case 2:
                    bounds = { left: pageDetails.width - bound.left - bound.width, top: pageDetails.height - bound.top - bound.height,
                        width: bound.width, height: bound.height };
                    break;
                case 3:
                    bounds = { left: bound.top - (bound.width / 2 - bound.height / 2), top: (pageDetails.height - bound.left -
                            bound.width + (bound.width / 2 - bound.height / 2)), width: bound.width, height: bound.height };
                    break;
            }
            if (!bounds) {
                bounds = bound;
            }
        }
        return bounds;
    }
    applyPosition(inputField, bounds, font, pageIndex, rotation, isFieldRotated) {
        if (bounds) {
            const left = this.ConvertPointToPixel(bounds.X);
            const top = this.ConvertPointToPixel(bounds.Y);
            const width = this.ConvertPointToPixel(bounds.Width);
            const height = this.ConvertPointToPixel(bounds.Height);
            let fontHeight = 0;
            const fieldBounds = { left: left, top: top, width: width, height: height };
            const annotBounds = this.getBounds(fieldBounds, pageIndex, rotation, isFieldRotated);
            if (!isNullOrUndefined(font) && font.Height) {
                inputField.style.fontFamily = font.Name;
                if (font.Italic) {
                    inputField.style.fontStyle = 'italic';
                }
                if (font.Bold) {
                    inputField.style.fontWeight = 'Bold';
                }
                fontHeight = this.ConvertPointToPixel(font.Size);
            }
            this.pdfViewerBase.setStyleToTextDiv(inputField, annotBounds.left, annotBounds.top, fontHeight, annotBounds.width, annotBounds.height, false);
        }
    }
    renderExistingAnnnot(data, index, printContainer, isFieldRotated) {
        if (!printContainer) {
            let bounds;
            if (data.Bounds && data.Name !== 'ink') {
                bounds = data.Bounds;
            }
            else {
                bounds = data.LineBounds;
            }
            let currentLeft;
            let currentTop;
            let currentWidth;
            let currentHeight;
            if (bounds.x || bounds.y || bounds.width || bounds.height) {
                currentLeft = bounds.x;
                currentTop = bounds.y;
                currentWidth = bounds.width;
                currentHeight = bounds.height;
            }
            else {
                currentLeft = this.ConvertPointToPixel(bounds.X);
                currentTop = this.ConvertPointToPixel(bounds.Y);
                currentWidth = this.ConvertPointToPixel(bounds.Width);
                currentHeight = this.ConvertPointToPixel(bounds.Height);
            }
            let bound;
            let newBounds;
            const currentPage = parseFloat(data['PageIndex']);
            if (this.pdfViewerBase.clientSideRendering && (data.Rotation === 1 || data.Rotation === 3)
                && (this.pdfViewerBase.isSignatureImageData(data.Value))) {
                bound = { left: currentLeft, top: currentTop, width: currentHeight, height: currentWidth };
                newBounds = this.updateSignatureImageBounds(bound, currentPage);
            }
            else {
                bound = { left: currentLeft, top: currentTop, width: currentWidth, height: currentHeight };
                newBounds = this.updateSignatureBounds(bound, currentPage, isFieldRotated);
            }
            let annot;
            const fontFamily = data.FontFamily ? data.FontFamily : data.fontFamily;
            if ((this.pdfViewerBase.isSignatureImageData(data.Value))) {
                annot = {
                    id: this.pdfViewer.element.id + 'input_' + currentPage + '_' + index, bounds: newBounds, pageIndex: currentPage, data: data.Value, modifiedDate: '',
                    shapeAnnotationType: 'SignatureImage', opacity: 1, rotateAngle: isFieldRotated || (this.pdfViewerBase.clientSideRendering &&
                        (data.Rotation === 1 || data.Rotation === 2 || data.Rotation === 3)) ? this.getAngle(currentPage) : 0, annotName: 'SignatureField', comments: [], review: { state: '', stateModel: '', modifiedDate: '', author: '' }
                };
            }
            else if (this.pdfViewerBase.isSignaturePathData(data.Value)) {
                let bound = newBounds;
                const tempBounds = { left: newBounds.x, top: newBounds.y, width: newBounds.width, height: newBounds.height };
                bound = this.updateSignatureBounds(tempBounds, currentPage, false);
                annot = {
                    id: this.pdfViewer.element.id + 'input_' + currentPage + '_' + index, bounds: bound, pageIndex: currentPage, data: data.Value, modifiedDate: '',
                    shapeAnnotationType: 'Path', opacity: 1, rotateAngle: 0, annotName: 'SignatureField', comments: [], review: { state: '', stateModel: '', modifiedDate: '', author: '' }
                };
            }
            else {
                annot = {
                    id: this.pdfViewer.element.id + 'input_' + currentPage + '_' + index, bounds: newBounds, pageIndex: currentPage, data: data.Value, modifiedDate: '',
                    shapeAnnotationType: 'SignatureText', opacity: 1, rotateAngle: isFieldRotated ? this.getAngle(currentPage) : 0, annotName: 'SignatureField', comments: [], review: { state: '', stateModel: '', modifiedDate: '', author: '' }, fontFamily: data.FontFamily, fontSize: data.FontSize
                };
                annot.fontFamily = fontFamily === 'TimesRoman' ? 'Times New Roman' : fontFamily;
                annot.fontSize = data.FontSize ? data.FontSize : data.fontSize;
            }
            if ((data.Name === 'SignatureField' || data.Name === 'InitialField') && !isNullOrUndefined(data.id)) {
                const elementId = data.id;
                const signatureFieldElement = document.getElementById(elementId + '_content_html_element');
                const signatureField = this.pdfViewer.nameTable[`${elementId}`];
                annot.id = signatureField.id + '_content';
                const obj = this.pdfViewer.add(annot);
                signatureField.wrapper.children.push(obj.wrapper);
                if (!isNullOrUndefined(signatureFieldElement) && this.isSignatureField) {
                    const inputField = signatureFieldElement.children[0].children[0];
                    inputField.style.pointerEvents = 'none';
                    inputField.className = 'e-pdfviewer-signatureformfields-signature';
                    inputField.parentElement.style.pointerEvents = 'none';
                }
                else if (!isNullOrUndefined(signatureFieldElement) && data.Value) {
                    const inputField = signatureFieldElement.children[0].children[0];
                    inputField.style.pointerEvents = 'none';
                    inputField.className = 'e-pdfviewer-signatureformfields-signature';
                    inputField.parentElement.style.pointerEvents = 'none';
                }
            }
            else {
                const target = document.getElementById(annot.id);
                if (target && target.classList.contains('e-pdfviewer-signatureformfields-signature')) {
                    this.pdfViewer.annotation.deleteAnnotationById(annot.id);
                }
                this.pdfViewer.add(annot);
                if (target) {
                    this.updateDataInSession(target, annot.data, annot.bounds);
                    this.pdfViewer.fireSignatureAdd(annot.pageIndex, annot.id, annot.shapeAnnotationType, annot.bounds, annot.opacity, annot.strokeColor, annot.thickness, annot.data);
                }
            }
            data.Bounds = annot.bounds;
            if (this.pdfViewer.formDesignerModule) {
                const zoomvalue = this.pdfViewerBase.getZoomFactor();
                annot.bounds = { x: currentLeft * zoomvalue, y: currentTop * zoomvalue, width: currentWidth * zoomvalue,
                    height: currentHeight * zoomvalue };
                this.updateSignatureDataInSession(annot, annot.id);
            }
            const canvass = this.pdfViewerBase.getAnnotationCanvas('_annotationCanvas_', currentPage);
            const obj = this.pdfViewer.formFieldCollection.filter((field) => { return annot.id.split('_')[0] === field.id; });
            if (obj.length > 0 && obj[0].visibility !== 'hidden' || !this.pdfViewer.formDesignerModule) {
                this.pdfViewer.renderDrawing(canvass, currentPage);
            }
        }
    }
    updateSignatureImageBounds(bound, pageIndex) {
        const pageDetails = this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)];
        if (pageDetails) {
            if (pageDetails.rotation === 1) {
                return { x: pageDetails.width - bound.top - bound.height - (bound.width / 2 - bound.height / 2),
                    y: bound.left - bound.width + (bound.width / 2 + bound.height / 2), width: bound.height, height: bound.width };
            }
            else if (pageDetails.rotation === 3) {
                return { x: bound.top + bound.width - (bound.width / 2 + bound.height / 2),
                    y: (pageDetails.height - bound.left - bound.width + (bound.width / 2 - bound.height / 2)),
                    width: bound.height, height: bound.width };
            }
            else {
                return { x: bound.left, y: bound.top, width: bound.width, height: bound.height };
            }
        }
    }
    /**
     * @param {any} bound - It describes about the bound
     * @param {number} pageIndex - It describes about the page index
     * @param {boolean} isFieldRotated - It describes about the isFieldRotated
     * @private
     * @returns {any} - any
     */
    updateSignatureBounds(bound, pageIndex, isFieldRotated) {
        const pageDetails = this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)];
        if (pageDetails) {
            if (!isFieldRotated) {
                if (pageDetails.rotation === 1) {
                    return { x: pageDetails.width - bound.top - bound.height, y: bound.left, width: bound.height, height: bound.width };
                }
                else if (pageDetails.rotation === 2) {
                    return { x: pageDetails.width - bound.left - bound.width, y: pageDetails.height - bound.top - bound.height,
                        width: bound.width, height: bound.height };
                }
                else if (pageDetails.rotation === 3) {
                    return { x: bound.top, y: (pageDetails.height - bound.left - bound.width), width: bound.height, height: bound.width };
                }
                else {
                    return { x: bound.left, y: bound.top, width: bound.width, height: bound.height };
                }
            }
            else {
                if (pageDetails.rotation === 1) {
                    return { x: pageDetails.width - bound.top - bound.height - (bound.width / 2 - bound.height / 2),
                        y: bound.left + (bound.width / 2 - bound.height / 2), width: bound.width, height: bound.height };
                }
                else if (pageDetails.rotation === 2) {
                    return { x: pageDetails.width - bound.left - bound.width, y: pageDetails.height - bound.top - bound.height,
                        width: bound.width, height: bound.height };
                }
                else if (pageDetails.rotation === 3) {
                    return { x: bound.top - (bound.width / 2 - bound.height / 2), y: (pageDetails.height - bound.left - bound.width +
                            (bound.width / 2 - bound.height / 2)), width: bound.width, height: bound.height };
                }
                else {
                    return { x: bound.left, y: bound.top, width: bound.width, height: bound.height };
                }
            }
        }
        else {
            return { x: bound.left, y: bound.top, width: bound.width, height: bound.height };
        }
    }
    resetFormFields() {
        const formFieldData = this.pdfViewer.formFieldCollections;
        for (let i = 0; i < formFieldData.length; i++) {
            const currentData = formFieldData[parseInt(i.toString(), 10)];
            this.currentTarget = document.getElementById(currentData.id);
            if (currentData.type === 'Textbox') {
                this.currentTarget.value = currentData.value;
            }
            else if (currentData.type === 'RadioButton') {
                this.currentTarget.checked = currentData.value;
                if (currentData.value) {
                    this.updateDataInSession(this.currentTarget);
                }
            }
            else if (currentData.type === 'DropDown') {
                this.currentTarget.value = currentData.value;
            }
            else if (currentData.type === 'CheckBox') {
                this.currentTarget.checked = currentData.value;
            }
            else if (currentData.type === 'SignatureField') {
                const annotation = this.pdfViewer.nameTable[currentData.id];
                if (annotation) {
                    if (this.currentTarget && this.currentTarget.className === 'e-pdfviewer-signatureformfields-signature') {
                        this.currentTarget.className = 'e-pdfviewer-signatureformfields';
                        this.currentTarget.style.pointerEvents = '';
                        this.updateDataInSession(this.currentTarget, '');
                    }
                    this.pdfViewer.remove(annotation);
                    this.pdfViewer.renderDrawing();
                }
            }
            if (currentData.type !== 'RadioButton' && currentData.type !== 'SignatureField') {
                this.updateDataInSession(this.currentTarget);
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    clearFormFieldStorage() {
        const sessionSize = PdfViewerBase.sessionStorageManager.getWindowSessionStorageSize();
        let maxSessionSize = 4500;
        if (this.pdfViewerBase.isDeviceiOS || this.pdfViewerBase.isMacSafari) {
            maxSessionSize = 2000;
        }
        if (this.pdfViewerBase.isStorageExceed) {
            const storageLength = PdfViewerBase.sessionStorageManager.getSessionLength();
            const formFieldsList = [];
            for (let i = 0; i < storageLength; i++) {
                if (PdfViewerBase.sessionStorageManager.getKey(i) && PdfViewerBase.sessionStorageManager.getKey(i).split('_')[3]) {
                    if (PdfViewerBase.sessionStorageManager.getKey(i).split('_')[3] === 'formfields') {
                        this.pdfViewerBase.formFieldStorage[PdfViewerBase.sessionStorageManager.getKey(i)] =
                            PdfViewerBase.sessionStorageManager.getItem(PdfViewerBase.sessionStorageManager.getKey(i));
                        formFieldsList.push(PdfViewerBase.sessionStorageManager.getKey(i));
                    }
                    else if (PdfViewerBase.sessionStorageManager.getKey(i).split('_')[3] === 'formDesigner') {
                        this.pdfViewerBase.formFieldStorage[PdfViewerBase.sessionStorageManager.getKey(i)] =
                            PdfViewerBase.sessionStorageManager.getItem(PdfViewerBase.sessionStorageManager.getKey(i));
                        formFieldsList.push(PdfViewerBase.sessionStorageManager.getKey(i));
                    }
                }
            }
            if (formFieldsList) {
                for (let i = 0; i < formFieldsList.length; i++) {
                    PdfViewerBase.sessionStorageManager.removeItem(formFieldsList[parseInt(i.toString(), 10)]);
                }
            }
        }
    }
    clearFormFields(formField) {
        let data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
        if (isNullOrUndefined(data)) {
            data = this.pdfViewerBase.getItemFromSessionStorage('_formDesigner');
        }
        if (data) {
            let formFieldsData;
            if (formField) {
                formFieldsData = [formField];
            }
            else {
                formFieldsData = JSON.parse(data);
            }
            let isFirstRadio = true;
            for (let m = 0; m < formFieldsData.length; m++) {
                const currentData = formFieldsData[parseInt(m.toString(), 10)];
                if (formField) {
                    currentData.uniqueID = formField.id;
                    currentData.Name = formField.type;
                }
                this.currentTarget = document.getElementById(currentData.uniqueID);
                if (currentData.Name === 'Textbox' || currentData.Name === 'PasswordField') {
                    this.currentTarget.value = '';
                }
                else if (currentData.Name === 'RadioButton') {
                    if (isFirstRadio) {
                        this.currentTarget.checked = true;
                        this.updateDataInSession(this.currentTarget);
                        isFirstRadio = false;
                    }
                }
                else if (currentData.Name === 'DropDown' || currentData.Name === 'DropdownList' || currentData.Name === 'ListBox') {
                    this.currentTarget.options.length = 0;
                    const selectedItem = this.pdfViewer.nameTable[this.currentTarget.id.split('_')[0]];
                    selectedItem.options = [];
                }
                else if (currentData.Name === 'CheckBox') {
                    this.currentTarget.checked = false;
                }
                else if (currentData.Name === 'SignatureField' || currentData.Name === 'InitialField') {
                    let annotation = this.pdfViewer.nameTable[currentData.uniqueID];
                    if (annotation.propName !== 'annotations') {
                        annotation = this.pdfViewer.nameTable[currentData.uniqueID + '_content'];
                    }
                    if (annotation) {
                        if (this.currentTarget && this.currentTarget.className === 'e-pdfviewer-signatureformfields-signature') {
                            this.currentTarget.className = 'e-pdfviewer-signatureformfields';
                            this.currentTarget.style.pointerEvents = '';
                            this.currentTarget.parentElement.style.pointerEvents = '';
                            this.updateDataInSession(this.currentTarget, '');
                            if (formField) {
                                formField.value = '';
                                formField.signatureType = [formField.signatureType];
                                formField.signatureType[0] = '';
                            }
                        }
                        this.pdfViewer.annotation.deleteAnnotationById(annotation.id);
                        this.currentTarget = null;
                    }
                }
                if (currentData.Name !== 'SignatureField' && currentData.Name !== 'ink' && currentData.Name !== 'RadioButton') {
                    this.updateDataInSession(this.currentTarget);
                }
            }
        }
    }
    /**
     * @param {any} number - It describes about the number
     * @private
     * @returns {number} - number
     */
    ConvertPointToPixel(number) {
        return (number * (96 / 72));
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.currentTarget = null;
        this.readOnlyCollection = [];
        if (this.pdfViewerBase && this.pdfViewerBase.signatureModule) {
            this.pdfViewerBase.signatureModule.destroy();
        }
    }
    /**
     * @private
     * @returns {string} - string
     */
    getModuleName() {
        return 'FormFields';
    }
}
